import clsx from 'clsx'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget10,
  TablesWidget10,
  TilesWidget2,
  TilesWidget5,
} from '../../../_metronic/partials/widgets'
import TablesWidget14 from '../../../_metronic/partials/widgets/tables/TablesWidget14'
import { useEffect, useMemo, useRef, useState } from 'react'
import { executeGet, executePost } from '../../../configs/Kubuku'
import {
  JMLKOLEKSI,
  JMLPENGGUNA,
  DURASIBACA,
  DURASIPENGGUNA,
  KOTA,
  KECAMATAN,
  PENGGUNATERBANYAK,
  KOLEKSITERBANYAK,
  PEMBACATERBANYAK,
  PENGUNJUNGTERBANYAK,
  KOLEKSITERBACATERBANYAK,
  DURASITERLAMA,
  JENJANG,
  MITRA,
  JMLPERPUS,
  JMLDURASIJAM,
  JMLKOLEKSIDIBACA,
  JMLPEMBACA,
  JUMLAHPENGUNJUNG,
  DURASIKOLEKSI,
  DURASIKUNJUNGAN,
  DURASIPEMBACA,
  DURASIKOLEKSIDIBACA,
  PERMINTAANBUKU,
  methodGet,
  DOWNLOADPENGGUNA,
  DOWNLOADDIBACA,
  DETAILPEMBACA,
  DETAILPENGGUNA,
  DETAILKUNJUNGAN,
  DETAILKOLEKSIDIBACA,
  DETAILKONTENDIBACAPermitra,
  DETAILDURASI,
  DOWNLOADPEMBACA,
  DOWNLOADDURASI,
  DOWNLOADDETAILPENGGUNA,
  DOWNLOADDETAILPEMBACA,
  DOWNLOADDETAILKOLEKSIDIBACA,
  DOWNLOADDETAILKONTENPERMITRA,
  DOWNLOADDETAILDURASI,
  DOWNLOADDETAILKUNJUNGAN,
  GETMITRA,
} from '../../../api'
import * as XLSX from 'xlsx'
import { getIdKota } from '../../../_metronic/partials/content/dropdown/globalFilter'
import { Dropdown1 } from '../../../_metronic/partials'
import { useThemeMode } from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import CreatableSelect from 'react-select/creatable'
import AsyncCreatableSelect from 'react-select/async-creatable'
import { ActionMeta, MultiValue } from 'react-select'
import DatePicker from 'react-datepicker'
import { Button, Modal, Spinner, Row, Col, Collapse } from 'react-bootstrap'
import Chart from 'chart.js/auto'
import { CategoryScale } from 'chart.js'
import KoleksiTerbacaTerbanyak from '../../../_metronic/partials/widgets/PieChart/koleksiTerbacaTerbanyak'
import JumlahPembaca from '../../../_metronic/partials/widgets/PieChart/jumlahPembaca'
import JumlahPengguna from '../../../_metronic/partials/widgets/PieChart/JumlahPengguna'
import JumlahKoleksiBukuPie from '../../../_metronic/partials/widgets/PieChart/JumlahKoleksiBukuPie'
import { getYearsRange, periodeOptions, monthOptions, StateOption } from '../../../data'
import TablesWidjetPembaca from '../../../_metronic/partials/widgets/tables/tablesWidgetPembaca'
import TablesWidgetKoleksiTerbacaTerbanyak from '../../../_metronic/partials/widgets/tables/tablesWidgetKoleksiTerbacaTerbanyak'
import TablesWidgetDurasiTerlama from '../../../_metronic/partials/widgets/tables/TablesWidgetDurasiTerlama'
import DurasiTerlama from '../../../_metronic/partials/widgets/PieChart/durasiTerlama'
import PengunjungTerbanyak from '../../../_metronic/partials/widgets/PieChart/pengunjungTerbanyak'
import TablesWidgetPengunjungTerbanyak from '../../../_metronic/partials/widgets/tables/TablesWidgetPengunjungTerbanyak'
import { ChartPengguna, FilterOption } from '../../../_metronic/partials/widgets/mixed/ChartPengguna'
import { ChartKoleksi } from '../../../_metronic/partials/widgets/mixed/ChartKoleksi'
import { ChartKunjungan } from '../../../_metronic/partials/widgets/mixed/ChartKunjungan'
import { get } from 'http'
import { ChartPembaca } from '../../../_metronic/partials/widgets/mixed/ChartPembaca'
import { ChartKoleksiDibaca } from '../../../_metronic/partials/widgets/mixed/ChartKoleksiDibaca'
import { formatDurasiJam } from '../../../_metronic/partials/widgets/mixed/chartPointClick'
import { json } from 'stream/consumers'
import TablePermintaanBuku from '../../../_metronic/partials/widgets/tables/TablePermintaanBuku'
import { Topbar } from '../../../_metronic/layout/components/header/Topbar'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'

Chart.register(CategoryScale)

const appendMitraIds = (formData: FormData, mitraList: FilterOption[]) => {
  mitraList.forEach((item) => {
    formData.append('id_mitra[]', item.value)
  })
}

type ChartPeriod = { thn: string; bln: string }

type DetailDownloadKey =
  | 'pengguna'
  | 'pembaca'
  | 'koleksiDibaca'
  | 'kontenPerMitra'
  | 'durasi'
  | 'kunjungan'

const downloadDetailExcel = async (
  url: string,
  formData: FormData,
  mapRow: (item: Record<string, unknown>, index: number) => Record<string, unknown>,
  fileName: string
) => {
  try {
    const response = await executePost(url, formData)
    if (response?.code !== 200 || !Array.isArray(response?.data)) {
      Swal.fire({
        icon: 'error',
        title: 'Gagal download',
        text: response?.msg || 'Data kosong',
      })
      return
    }

    const rows = response.data.map((item: Record<string, unknown>, index: number) =>
      mapRow(item, index)
    )
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, fileName)
  } catch (error) {
    console.error('downloadDetailExcel:', error)
    Swal.fire({ icon: 'error', title: 'Terjadi kesalahan saat download' })
  }
}

const DashboardPage = () => {
  const [jumlahPerpus, setJumlahPerpus] = useState(0)
  const [jumlahPengguna, setJumlahPengguna] = useState(0)
  const [jumlahKoleksi, setJumlahKoleksi] = useState(0)
  const [jumlahPengunjung, setJumlahPengunjung] = useState(0)
  const [jumlahDurasi, setJumlahDurasi] = useState(0)
  const [jumlahKoleksiDibaca, setJumlahKoleksiDibaca] = useState(0)
  const [jumlahPembaca, setJumlahPembaca] = useState(0)
  const [durasiBaca, setDurasiBaca] = useState([])
  const [labels, setLabels] = useState([])
  const [totalJam, setTotalJam] = useState(0)
  const [durasiPengguna, setDurasiPengguna] = useState([])
  const [labelsPengguna, setLabelsPengguna] = useState([])
  const [totalPengguna, setTotalPengguna] = useState(0)
  const [durasiKoleksi, setDurasiKoleksi] = useState([])
  const [labelsKoleksi, setLabelsKoleksi] = useState([])
  const [totalKoleksi, setTotalKoleksi] = useState(0)
  const [durasiKunjungan, setDurasiKunjungan] = useState([])
  const [labelsKunjungan, setLabelsKunjungan] = useState([])
  const [totalKunjungan, setTotalKunjungan] = useState(0)
  const [durasiPembaca, setDurasiPembaca] = useState([])
  const [labelsPembaca, setLabelsPembaca] = useState([])
  const [totalPembaca, setTotalPembaca] = useState(0)
  const [durasiKoleksiDibaca, setDurasiKoleksiDibaca] = useState([])
  const [labelsKoleksiDibaca, setLabelsKoleksiDibaca] = useState([])
  const [totalKoleksiDibaca, setTotalKoleksiDibaca] = useState(0)
  const { mode } = useThemeMode()
  const [idKota, setIdKota] = useState('')
  const [namaKota, setNamakota] = useState('')
  const [idKecamatan, setIdKecamatan] = useState('')
  const [idJenjang, setIdJenjang] = useState('')
  const [namaJenjang, setNamaJenjang] = useState('')
  const [selectedMitra, setSelectedMitra] = useState<FilterOption[]>([])
  const [periode, setPeriode] = useState('bulan')
  const [isFilterExpanded, setIsFilterExpanded] = useState(false)
  const [toggleHover, setToggleHover] = useState(false)
  const filterRef = useRef<HTMLDivElement>(null)
  const sentinelRef = useRef<HTMLDivElement>(null)
  const lastScrollY = useRef(0)
  const isFilterExpandedRef = useRef(isFilterExpanded)
  const isFilterStuckRef = useRef(false)
  const ignoreCollapseUntil = useRef(0)
  const manualExpandRef = useRef(false)
  const [stickyTop, setStickyTop] = useState(80)
  const [isFilterStuck, setIsFilterStuck] = useState(false)

  isFilterExpandedRef.current = isFilterExpanded
  isFilterStuckRef.current = isFilterStuck
  const [showPeriodeAwalAkhir, setShowPeriodeAwalAkhir] = useState(true)
  const [periodeAwal, setPeriodeAwal] = useState('01')
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const date = currentMonth < 10 ? `0${currentMonth}` : currentMonth.toString();
  const [periodeAkhir, setPeriodeAkhir] = useState(date);
  const [bulanAwal, setBulanAwal] = useState('Januari');

  const bulan = {
    1: 'Januari',
    2: 'Februari',
    3: 'Maret',
    4: 'April',
    5: 'Mei',
    6: 'Juni',
    7: 'Juli',
    8: 'Agustus',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Desember',
  };

  const namaBulanAkhir = bulan[parseInt(periodeAkhir, 10)]; // Mengonversi string ke angka

  const [bulanAkhir, setBulanAkhir] = useState(namaBulanAkhir);

  const [tahunAwal, setTahunAwal] = useState(new Date().getFullYear().toString())
  const [tahunAkhir, setTahunAkhir] = useState(new Date().getFullYear().toString())
  const initialSelectData: {options: FilterOption[]} = {options: []}
  const [selectDataKota, setSelectDataKota] = useState(initialSelectData)
  const [selectDataKecamatan, setSelectDataKecamatan] = useState(initialSelectData)
  const [selectDataJenjang, setSelectDataJenjang] = useState(initialSelectData)
  const [selectDataMitra, setSelectDataMitra] = useState(initialSelectData)
  const [penggunaTerbanyak, setPenggunaTerbanyak] = useState<
    {
      nama: string
      total_pengguna: string
    }[]
  >([])
  const [chartData, setChartData] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  const [pembacaTerbanyak, setPembacaTerbanyak] = useState<
    {
      id_mitra: number
      logo: string
      nama: string
      jumlah_total_pembaca: string
    }[]
  >([])
  const [chartDataPembaca, setChartDataPembaca] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  const [pengunjungTerbanyak, setPengunjungTerbanyak] = useState<
    {
      id_mitra: number
      logo: string
      nama: string
      total_pengunjung: string
    }[]
  >([])
  const [chartDataPengunjungTerbanyak, setChartDataPengunjungTerbanyak] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  const [durasiTerlama, setDurasiTerlama] = useState<
    {
      id_mitra: number
      logo: string
      nama: string
      total_durasi_jam: string
    }[]
  >([])
  const [chartDataDurasiTerlama, setChartDataDurasiTerlama] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  const [koleksiTerbacaTerbanyak, setKoleksiTerbacaTerbanyak] = useState<
    {
      id_mitra: number
      logo: string
      nama: string
      jumlah_koleksi_dibaca: string
    }[]
  >([])
  const [chartDataKoleksiTerbacaTerbanyak, setchartDataKoleksiTerbacaTerbanyak] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  const [koleksiTerbanyak, setKoleksiTerbanyak] = useState<
    {
      id_mitra: number
      logo: string
      nama: string
      total_koleksi: string
    }[]
  >([])

  const [chartDataKoleksi, setChartDataKoleksi] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  const [tabelPengunjungTerbanyak, setTabelPengunjungTerbanyak] = useState([])
  const [tabelDurasiTerlama, setTabelDurasiTerlama] = useState([])
  const [tabelKoleksiTerbacaTerbanyak, setTabelKoleksiTerbacaTerbanyak] = useState([])
  const [tabelPembacaTerbanyak, setTabelPembacaTerbanyak] = useState([])
  const [tabelPenggunaTerbanyak, setTabelPenggunaTerbanyak] = useState([])
  // const [tabelDownloadPengguna, setTabelDownloadPengguna] = useState([])
  const [tabelKoleksiTebanyak, setTabelKoleksiTerbanyak] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingJumlahPerpus, setLoadingJumlahPerpus] = useState(true)
  const [loadingJumlahPengguna, setLoadingJumlahPengguna] = useState(true)
  const [loadingJumlahKoleksi, setLoadingJumlahKoleksi] = useState(true)
  const [loadingDurasiBaca, setLoadingDurasiBaca] = useState(true)
  const [loadingDurasiPengguna, setLoadingDurasiPengguna] = useState(true)
  const [loadingDurasiKoleksi, setLoadingDurasiKoleksi] = useState(true)
  const [loadingDurasiKunjungan, setLoadingDurasiKunjungan] = useState(true)
  const [loadingDurasiPembaca, setLoadingDurasiPembaca] = useState(true)
  const [loadingDurasiKoleksiDibaca, setLoadingDurasiKoleksiDibaca] = useState(true)
  const [showModalKoleksiDibaca, setShowModalKoleksiDibaca] = useState(false)
  const [selectedLabelKoleksiDibaca, setSelectedLabelKoleksiDibaca] = useState('')
  const [selectedValueKoleksiDibaca, setSelectedValueKoleksiDibaca] = useState(0)
  const [listKoleksiDibacaDetail, setListKoleksiDibacaDetail] = useState<
  {
    id_mitra?: string
    nama?: string
    kota?: string
    jumlah?: string | number
    jumlah_koleksi_dibaca?: string | number
  }[]
>([])
  const [loadingListKoleksiDibaca, setLoadingListKoleksiDibaca] = useState(false)
  const [koleksiDibacaPeriod, setKoleksiDibacaPeriod] = useState<ChartPeriod | null>(null)
  const [pembacaPeriod, setPembacaPeriod] = useState<ChartPeriod | null>(null)
  const [durasiPeriod, setDurasiPeriod] = useState<ChartPeriod | null>(null)
  const [penggunaPeriod, setPenggunaPeriod] = useState<ChartPeriod | null>(null)
  const [kunjunganPeriod, setKunjunganPeriod] = useState<ChartPeriod | null>(null)
  const [downloadingDetail, setDownloadingDetail] = useState<Record<DetailDownloadKey, boolean>>({
    pengguna: false,
    pembaca: false,
    koleksiDibaca: false,
    kontenPerMitra: false,
    durasi: false,
    kunjungan: false,
  })
  const [showModalKontenPerMitra, setShowModalKontenPerMitra] = useState(false)
  const [selectedMitraKoleksi, setSelectedMitraKoleksi] = useState<{ id: string; nama: string } | null>(
    null
  )
  const [listKontenPerMitra, setListKontenPerMitra] = useState<
    {
      id_konten?: string
      judul?: string
      nama?: string
      penulis?: string
      jumlah?: string | number
      jumlah_konten_dibaca?: string | number
      jumlah_dibaca?: string | number
    }[]
  >([])
  const [loadingKontenPerMitra, setLoadingKontenPerMitra] = useState(false)
  const [showModalPembaca, setShowModalPembaca] = useState(false)
  const [selectedLabelPembaca, setSelectedLabelPembaca] = useState('')
  const [selectedValuePembaca, setSelectedValuePembaca] = useState(0)
  const [listPembacaDetail, setListPembacaDetail] = useState<
    {
      id_mitra?: string
      nama?: string
      kota?: string
      jumlah?: string | number
      jumlah_total_pembaca?: string | number
    }[]
  >([])
  const [loadingListPembaca, setLoadingListPembaca] = useState(false)
  const [showModalDurasiBaca, setShowModalDurasiBaca] = useState(false)
  const [selectedLabelDurasiBaca, setSelectedLabelDurasiBaca] = useState('')
  const [selectedValueDurasiBaca, setSelectedValueDurasiBaca] = useState(0)
  const [listDurasiBacaDetail, setListDurasiBacaDetail] = useState<
    {
      id_mitra?: string
      nama?: string
      kota?: string
      durasi_jam_convert?: string
      total_durasi_jam?: string | number
      jumlah?: string | number   // fallback jika API pakai field ini
    }[]
  >([])
  const [loadingListDurasiBaca, setLoadingListDurasiBaca] = useState(false)
  const [showModalPengguna, setShowModalPengguna] = useState(false)
  const [selectedLabelPengguna, setSelectedLabelPengguna] = useState('')
  const [selectedValuePengguna, setSelectedValuePengguna] = useState(0)
  const [listPenggunaDetail, setListPenggunaDetail] = useState<
    {
      id_mitra?: string
      nama?: string
      kota?: string
      total_pengguna?: string | number
      jumlah_total_pengguna?: string | number
      jumlah?: string | number
    }[]
  >([])
  const [loadingListPengguna, setLoadingListPengguna] = useState(false)
  const [showModalKunjungan, setShowModalKunjungan] = useState(false)
  const [selectedLabelKunjungan, setSelectedLabelKunjungan] = useState('')
  const [selectedValueKunjungan, setSelectedValueKunjungan] = useState(0)
  const [listKunjunganDetail, setListKunjunganDetail] = useState<
    {
      id_mitra?: string
      nama?: string
      kota?: string
      jumlah?: string | number
      total_kunjungan?: string | number
    }[]
  >([])
  const [loadingListKunjungan, setLoadingListKunjungan] = useState(false)
  const [loadingDataPenggunaTerbanyak, setLoadingDataPenggunaTerbanyak] = useState(true)
  const [loadingDataDurasiTerlama, setLoadingDataDurasiTerlama] = useState(true)
  const [loadingDataKoleksiTerbacaTerbanyak, setLoadingDataKoleksiTerbacaTerbanyak] = useState(true)
  const [loadingDataPembacaTerbanyak, setLoadingDataPembacaTerbanyak] = useState(true)
  const [loadingPengunjungTerbanyak, setLoadingPengunjungTerbanyak] = useState(true)
  const [loadingDataJumlahPengunjung, setLoadingDataJumlahPengunjung] = useState(true)
  const [loadingJumlahDurasiBaca, setLoadingJumlahDurasiBaca] = useState(true)
  const [loadingJumlahKoleksiDibaca, setLoadingJumlahKoleksiDibaca] = useState(true)
  const [loadingJumlahPembaca, setLoadingJumlahPembaca] = useState(true)
  const [loadingDataKoleksiTerbanyak, setLoadingDataKoleksiTerbanyak] = useState(true)
  const [loadingPermintaanBuku, setLoadingPermintaanBuku] = useState(true)
  const [searchParams, setSearchParams] = useState('')
  const [permintaanBuku, setPermintaanBuku] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [perPage, setPerPage] = useState(10)

  function formatPeriodeLabel(startMonth, startYear, endMonth, endYear) {
    const startDate = new Date(startYear, startMonth - 1)
    const endDate = new Date(endYear, endMonth - 1)

    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    const formattedStart = `${monthNames[startDate.getMonth()]} ${startDate.getFullYear()}`
    const formattedEnd = `${monthNames[endDate.getMonth()]} ${endDate.getFullYear()}`

    return `${formattedStart} - ${formattedEnd}`
  }

  const GetDataJumlahPerpus = async () => {
    try {
      setLoadingJumlahPerpus(true)

      const response = await executePost(JMLPERPUS)
      const jumlah_perpusAPI = response?.data?.jumlah_perpus || '0'
      const jumlahPerpusNumber = Number(jumlah_perpusAPI);

      setJumlahPerpus(jumlahPerpusNumber)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingJumlahPerpus(false)
    }
  }

  useEffect(() => {
    const updateStickyTop = () => {
      const header = document.getElementById('kt_header')
      setStickyTop(header?.offsetHeight ?? 80)
    }
    updateStickyTop()
    window.addEventListener('resize', updateStickyTop)
    return () => window.removeEventListener('resize', updateStickyTop)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (Date.now() < ignoreCollapseUntil.current) return
      if (manualExpandRef.current) return
      if (!isFilterExpandedRef.current || !isFilterStuckRef.current) return

      // Jangan collapse saat dropdown react-select terbuka
      if (document.querySelector('[aria-expanded="true"][role="combobox"]')) return

      // Jangan collapse jika fokus masih di dalam filter
      if (filterRef.current?.contains(document.activeElement)) return

      const currentY = window.scrollY
      const scrollDelta = currentY - lastScrollY.current

      if (scrollDelta > 80) {
        setIsFilterExpanded(false)
      }
      lastScrollY.current = currentY
    }

    lastScrollY.current = window.scrollY
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [stickyTop])

  useEffect(() => {
    const sentinel = sentinelRef.current
    if (!sentinel) return
    const observer = new IntersectionObserver(
      ([entry]) => setIsFilterStuck(!entry.isIntersecting),
      { rootMargin: `-${stickyTop}px 0px 0px 0px`, threshold: 0 }
    )
    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [stickyTop])

  useEffect(() => {
    GetDataJumlahPerpus()
  }, [])

  const GetDataJumlahPengguna = async () => {
    try {
      setLoadingJumlahPengguna(true)

      const response = await executePost(JMLPENGGUNA)
      const data = response?.data?.jumlah_pengguna
      const jumlahPengguna = Number(data);

      setJumlahPengguna(jumlahPengguna)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingJumlahPengguna(false)
    }
  }

  const GetDataJumlahKoleksi = async () => {
    try {
      setLoadingJumlahKoleksi(true)

      const response = await executePost(JMLKOLEKSI)
      const data = response?.data?.jumlah_koleksi
      const jumlahKoleksi = Number(data);
      setJumlahKoleksi(jumlahKoleksi)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingJumlahKoleksi(false)
    }
  }

  const getDurasiBaca = async () => {
    try {
      setLoadingDurasiBaca(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASIBACA, formData)

      if (response.code === 200) {
        setLabels(response.labels)
        setDurasiBaca(response.data || [])
        setTotalJam(response.total_jam)
      }
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
    } finally {
      setLoadingDurasiBaca(false)
    }
  }

  const getDurasiPengguna = async () => {
    try {
      setLoadingDurasiPengguna(true)

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
      formData.append('jenis_periode', periode)
      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASIPENGGUNA, formData)

      if (response.code === 200) {
        setLabelsPengguna(response.label)
        setDurasiPengguna(response.data || [])
        setTotalPengguna(response.total_Pengguna)
      } else {
        setLabelsPengguna([])
        setDurasiPengguna([])
        setTotalPengguna(0)
      }
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
    } finally {
      setLoadingDurasiPengguna(false)
    }
  }

  const getDurasiKoleksi = async () => {
    try {
      setLoadingDurasiKoleksi(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASIKOLEKSI, formData)

      if (response.code === 200) {
        setLabelsKoleksi(response.label)
        setDurasiKoleksi(response.data || [])
        setTotalKoleksi(response.total_Koleksi)
      }
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
    } finally {
      setLoadingDurasiKoleksi(false)
    }
  }

  const getDurasiKunjungan = async () => {
    try {
      setLoadingDurasiKunjungan(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASIKUNJUNGAN, formData)

      if (response.code === 200) {
        setLabelsKunjungan(response.label)
        setDurasiKunjungan(response.data || [])
        setTotalKunjungan(response.total_kunjungan)
      }
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
    } finally {
      setLoadingDurasiKunjungan(false)
    }
  }

  const getDurasiPembaca = async () => {
    try {
      setLoadingDurasiPembaca(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASIPEMBACA, formData)

      if (response.code === 200) {
        setLabelsPembaca(response.label)
        setDurasiPembaca(response.data || [])
        setTotalPembaca(response.total_pembaca)
      }
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
    } finally {
      setLoadingDurasiPembaca(false)
    }
  }

  const getDurasiKoleksiDibaca = async () => {
    try {
      setLoadingDurasiKoleksiDibaca(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASIKOLEKSIDIBACA, formData)

      if (response.code === 200) {
        setLabelsKoleksiDibaca(response.label)
        setDurasiKoleksiDibaca(response.data || [])
        setTotalKoleksiDibaca(response.total_koleksidibaca)
      }
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
    } finally {
      setLoadingDurasiKoleksiDibaca(false)
    }
  }

  const parseChartMonthLabel = (label: string) => {
    const monthMap: Record<string, string> = {
      jan: '01',
      januari: '01',
      feb: '02',
      februari: '02',
      mar: '03',
      maret: '03',
      apr: '04',
      april: '04',
      mei: '05',
      may: '05',
      jun: '06',
      juni: '06',
      jul: '07',
      juli: '07',
      agu: '08',
      agustus: '08',
      aug: '08',
      august: '08',
      sep: '09',
      september: '09',
      okt: '10',
      oktober: '10',
      oct: '10',
      october: '10',
      nov: '11',
      november: '11',
      des: '12',
      desember: '12',
      dec: '12',
      december: '12',
    }
    const parts = String(label).trim().split(/\s+/)
    if (parts.length < 2) {
      return null
    }
    const monthKey = parts[0].replace('.', '').toLowerCase()
    const thn = parts[parts.length - 1]
    const bln = monthMap[monthKey]
    if (!bln || !/^\d{4}$/.test(thn)) {
      return null
    }
    return {bln, thn}
  }

  const formatChartLabelForApi = (label: string) => {
    const trimmed = String(label).trim()
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed
    }
    if (/^\d{4}-\d{2}$/.test(trimmed)) {
      return `${trimmed}-01`
    }
    const parsed = parseChartMonthLabel(trimmed)
    if (parsed) {
      return `${parsed.thn}-${parsed.bln}-01`
    }
    return trimmed
  }

  const getChartLabelAtIndex = (
    chartLabels: unknown[],
    index: number,
    fallback: string
  ) => {
    if (index >= 0 && chartLabels[index] != null) {
      return String(chartLabels[index])
    }
    return fallback
  }

  const resolveMonthYearFromChartLabel = (rawLabel: string, defaultYear: string) => {
    const trimmed = String(rawLabel).trim()
    if (/^\d{1,2}$/.test(trimmed)) {
      return {bln: trimmed.padStart(2, '0'), thn: defaultYear}
    }
    const parsed = parseChartMonthLabel(trimmed)
    if (parsed) {
      return parsed
    }
    const apiLabel = formatChartLabelForApi(trimmed)
    if (/^\d{4}-\d{2}-\d{2}$/.test(apiLabel)) {
      const [thn, bln] = apiLabel.split('-')
      return {thn, bln}
    }
    return null
  }

  const formatChartPointDisplayLabel = (rawLabel: string, defaultYear: string) => {
    const resolved = resolveMonthYearFromChartLabel(rawLabel, defaultYear)
    if (!resolved) {
      return rawLabel
    }
    const monthNumber = parseInt(resolved.bln, 10)
    const monthName = bulan[monthNumber as keyof typeof bulan]
    return monthName ? `${monthName} ${resolved.thn}` : rawLabel
  }

  const handleKoleksiDibacaPointClick = async (
    label: string,
    value: number,
    index: number
  ) => {
    const monthLabel = getChartLabelAtIndex(labelsKoleksiDibaca, index, label)
    const displayLabel = formatChartPointDisplayLabel(monthLabel, tahunAkhir)
    setSelectedLabelKoleksiDibaca(displayLabel)
    setSelectedValueKoleksiDibaca(value)
    setShowModalKoleksiDibaca(true)
    setLoadingListKoleksiDibaca(true)
    setListKoleksiDibacaDetail([])
    setShowModalKontenPerMitra(false)
    setSelectedMitraKoleksi(null)
    setListKontenPerMitra([])

    try {
      if (!monthLabel) {
        console.warn('handleKoleksiDibacaPointClick: label kosong')
        return
      }

      const resolved = resolveMonthYearFromChartLabel(monthLabel, tahunAkhir)
      if (!resolved) {
        console.warn('handleKoleksiDibacaPointClick: gagal resolve bulan/tahun dari', monthLabel)
        return
      }

      setKoleksiDibacaPeriod({ thn: resolved.thn, bln: resolved.bln })

      const formData = new FormData()
      formData.append('jenis_periode', periode)   // 'bulan' — jangan hardcode jika filter bisa berubah
      formData.append('thn', resolved.thn)
      formData.append('bln', resolved.bln)
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
  
      const response = await executePost(DETAILKOLEKSIDIBACA, formData)
      if (response?.code !== 200) {
        console.error('detailChartKoleksiDibaca:', response?.msg || response)
        return
      }
      setListKoleksiDibacaDetail(Array.isArray(response?.data) ? response.data : [])
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
      setListKoleksiDibacaDetail([])
    } finally {
      setLoadingListKoleksiDibaca(false)
    }
  }

  const handleKoleksiMitraClick = async (item: { id_mitra?: string; nama?: string }) => {
    if (!item.id_mitra || !koleksiDibacaPeriod) {
      console.warn('handleKoleksiMitraClick: id_mitra atau periode belum tersedia')
      return
    }

    setSelectedMitraKoleksi({ id: item.id_mitra, nama: item.nama || '-' })
    setShowModalKontenPerMitra(true)
    setLoadingKontenPerMitra(true)
    setListKontenPerMitra([])

    try {
      const formData = new FormData()
      formData.append('jenis_periode', periode)
      formData.append('thn', koleksiDibacaPeriod.thn)
      formData.append('bln', koleksiDibacaPeriod.bln)
      formData.append('id_mitra', item.id_mitra)

      const response = await executePost(DETAILKONTENDIBACAPermitra, formData)
      if (response?.code !== 200) {
        console.error('detailKontenDibacaPerMitra:', response?.msg || response)
        return
      }
      setListKontenPerMitra(Array.isArray(response?.data) ? response.data : [])
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
      setListKontenPerMitra([])
    } finally {
      setLoadingKontenPerMitra(false)
    }
  }

  const closeModalKoleksiDibaca = () => {
    setShowModalKoleksiDibaca(false)
    setShowModalKontenPerMitra(false)
    setKoleksiDibacaPeriod(null)
    setSelectedMitraKoleksi(null)
    setListKontenPerMitra([])
  }

  const setDetailDownloading = (key: DetailDownloadKey, value: boolean) => {
    setDownloadingDetail((prev) => ({ ...prev, [key]: value }))
  }

  const buildChartDetailFormData = (period: ChartPeriod) => {
    const formData = new FormData()
    formData.append('jenis_periode', periode)
    formData.append('thn', period.thn)
    formData.append('bln', period.bln)
    formData.append('id_kota', idKota)
    formData.append('id_tipe', idJenjang)
    appendMitraIds(formData, selectedMitra)
    return formData
  }

  const runDetailDownload = async (
    key: DetailDownloadKey,
    url: string,
    formData: FormData,
    mapRow: (item: Record<string, unknown>, index: number) => Record<string, unknown>,
    fileName: string
  ) => {
    setDetailDownloading(key, true)
    try {
      await downloadDetailExcel(url, formData, mapRow, fileName)
    } finally {
      setDetailDownloading(key, false)
    }
  }

  const handleDownloadPenggunaDetail = async () => {
    if (!penggunaPeriod) {
      Swal.fire({ icon: 'warning', title: 'Periode belum tersedia' })
      return
    }
    await runDetailDownload(
      'pengguna',
      DOWNLOADDETAILPENGGUNA,
      buildChartDetailFormData(penggunaPeriod),
      (item) => ({
        ID_MITRA: item.id_mitra,
        NAMA: item.nama,
        JUMLAH_PENGGUNA: Number(
          item.total_pengguna ?? item.jumlah_total_pengguna ?? item.jumlah ?? 0
        ).toLocaleString('id-ID'),
      }),
      `Pengguna — ${selectedLabelPengguna}.xlsx`
    )
  }

  const handleDownloadPembacaDetail = async () => {
    if (!pembacaPeriod) {
      Swal.fire({ icon: 'warning', title: 'Periode belum tersedia' })
      return
    }
    await runDetailDownload(
      'pembaca',
      DOWNLOADDETAILPEMBACA,
      buildChartDetailFormData(pembacaPeriod),
      (item) => ({
        ID_MITRA: item.id_mitra,
        NAMA: item.nama,
        JUMLAH_PEMBACA: Number(item.jumlah_total_pembaca ?? item.jumlah ?? 0).toLocaleString(
          'id-ID'
        ),
      }),
      `Pembaca — ${selectedLabelPembaca}.xlsx`
    )
  }

  const handleDownloadKoleksiDibacaDetail = async () => {
    if (!koleksiDibacaPeriod) {
      Swal.fire({ icon: 'warning', title: 'Periode belum tersedia' })
      return
    }
    await runDetailDownload(
      'koleksiDibaca',
      DOWNLOADDETAILKOLEKSIDIBACA,
      buildChartDetailFormData(koleksiDibacaPeriod),
      (item) => ({
        ID_MITRA: item.id_mitra,
        NAMA: item.nama,
        JUMLAH_KOLEKSI_DIBACA: Number(item.jumlah_koleksi_dibaca ?? item.jumlah ?? 0).toLocaleString(
          'id-ID'
        ),
      }),
      `Koleksi Dibaca — ${selectedLabelKoleksiDibaca}.xlsx`
    )
  }

  const handleDownloadKontenPerMitra = async () => {
    if (!koleksiDibacaPeriod || !selectedMitraKoleksi?.id) {
      Swal.fire({ icon: 'warning', title: 'Periode atau mitra belum tersedia' })
      return
    }
    const formData = new FormData()
    formData.append('jenis_periode', periode)
    formData.append('thn', koleksiDibacaPeriod.thn)
    formData.append('bln', koleksiDibacaPeriod.bln)
    formData.append('id_mitra', selectedMitraKoleksi.id)
    await runDetailDownload(
      'kontenPerMitra',
      DOWNLOADDETAILKONTENPERMITRA,
      formData,
      (item, index) => ({
        NO: index + 1,
        JUDUL_BUKU: item.judul ?? item.nama ?? '-',
        JUMLAH_KONTEN_DIBACA: Number(
          item.jumlah_dibaca ?? item.jumlah_konten_dibaca ?? item.jumlah ?? 0
        ).toLocaleString('id-ID'),
      }),
      `Konten Dibaca — ${selectedMitraKoleksi.nama} — ${selectedLabelKoleksiDibaca}.xlsx`
    )
  }

  const handleDownloadDurasiDetail = async () => {
    if (!durasiPeriod) {
      Swal.fire({ icon: 'warning', title: 'Periode belum tersedia' })
      return
    }
    await runDetailDownload(
      'durasi',
      DOWNLOADDETAILDURASI,
      buildChartDetailFormData(durasiPeriod),
      (item) => ({
        ID_MITRA: item.id_mitra,
        NAMA: item.nama,
        DURASI: formatDurasiJam(
          Number(item.jumlah ?? item.durasi_jam_convert ?? item.total_durasi_jam ?? 0)
        ),
      }),
      `Durasi Baca — ${selectedLabelDurasiBaca}.xlsx`
    )
  }

  const handleDownloadKunjunganDetail = async () => {
    if (!kunjunganPeriod) {
      Swal.fire({ icon: 'warning', title: 'Periode belum tersedia' })
      return
    }
    await runDetailDownload(
      'kunjungan',
      DOWNLOADDETAILKUNJUNGAN,
      buildChartDetailFormData(kunjunganPeriod),
      (item) => ({
        ID_MITRA: item.id_mitra,
        NAMA: item.nama,
        JUMLAH_KUNJUNGAN: Number(item.total_kunjungan ?? item.jumlah ?? 0).toLocaleString('id-ID'),
      }),
      `Kunjungan — ${selectedLabelKunjungan}.xlsx`
    )
  }

  const renderDetailDownloadButton = (
    downloadKey: DetailDownloadKey,
    onClick: () => void,
    listLoading: boolean
  ) => (
    <Button
      variant='success'
      onClick={onClick}
      disabled={downloadingDetail[downloadKey] || listLoading}
    >
      {downloadingDetail[downloadKey] ? (
        <>
          <Spinner animation='border' size='sm' className='me-2' />
          Mengunduh...
        </>
      ) : (
        'Download Excel'
      )}
    </Button>
  )

  const handlePembacaPointClick = async (label: string, value: number, index: number) => {
    const monthLabel = getChartLabelAtIndex(labelsPembaca, index, label)
    const displayLabel = formatChartPointDisplayLabel(monthLabel, tahunAkhir)
    setSelectedLabelPembaca(displayLabel)
    setSelectedValuePembaca(value)
    setShowModalPembaca(true)
    setLoadingListPembaca(true)
    setListPembacaDetail([])

    try {
      if (!monthLabel) {
        console.warn('handlePembacaPointClick: label kosong')
        setListPembacaDetail([])
        return
      }

      const resolved = resolveMonthYearFromChartLabel(monthLabel, tahunAkhir)
      if (!resolved) {
        console.warn('handlePembacaPointClick: gagal resolve bulan/tahun dari', monthLabel)
        setListPembacaDetail([])
        return
      }

      setPembacaPeriod({ thn: resolved.thn, bln: resolved.bln })

      const formData = new FormData()
      formData.append('jenis_periode', periode)
      formData.append('thn', resolved.thn)
      formData.append('bln', resolved.bln)
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)

      const response = await executePost(DETAILPEMBACA, formData)
      if (response?.code !== 200) {
        console.error('detailChartPembaca:', response?.msg || response)
        setListPembacaDetail([])
        return
      }
      const data = response?.data
      setListPembacaDetail(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
      setListPembacaDetail([])
    } finally {
      setLoadingListPembaca(false)
    }
  }

  const handleDurasiBacaPointClick = async (label: string, value: number, index: number) => {
    const monthLabel = getChartLabelAtIndex(labels, index, label)
    const displayLabel = formatChartPointDisplayLabel(monthLabel, tahunAkhir)
    setSelectedLabelDurasiBaca(displayLabel)
    setSelectedValueDurasiBaca(value)
    setShowModalDurasiBaca(true)
    setLoadingListDurasiBaca(true)
    setListDurasiBacaDetail([])
  
    try {
      if (!monthLabel) {
        console.warn('handleDurasiBacaPointClick: label kosong')
        return
      }
  
      const resolved = resolveMonthYearFromChartLabel(monthLabel, tahunAkhir)
      if (!resolved) {
        console.warn('handleDurasiBacaPointClick: gagal resolve bulan/tahun dari', monthLabel)
        return
      }

      setDurasiPeriod({ thn: resolved.thn, bln: resolved.bln })
  
      const formData = new FormData()
      formData.append('jenis_periode', periode)   // 'bulan' — ikuti filter dashboard
      formData.append('thn', resolved.thn)
      formData.append('bln', resolved.bln)
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)
  
      const response = await executePost(DETAILDURASI, formData)
      if (response?.code !== 200) {
        console.error('detailChartDurasi:', response?.msg || response)
        return
      }
      setListDurasiBacaDetail(Array.isArray(response?.data) ? response.data : [])
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
      setListDurasiBacaDetail([])
    } finally {
      setLoadingListDurasiBaca(false)
    }
  }

  const handlePenggunaPointClick = async (label: string, value: number, index: number) => {
    const monthLabel = getChartLabelAtIndex(labelsPengguna, index, label)
    const displayLabel = formatChartPointDisplayLabel(monthLabel, tahunAkhir)
    setSelectedLabelPengguna(displayLabel)
    setSelectedValuePengguna(value)
    setShowModalPengguna(true)
    setLoadingListPengguna(true)
    setListPenggunaDetail([])

    try {
      if (!monthLabel) {
        console.warn('handlePenggunaPointClick: label kosong')
        setListPenggunaDetail([])
        return
      }

      const resolved = resolveMonthYearFromChartLabel(monthLabel, tahunAkhir)
      if (!resolved) {
        console.warn('handlePenggunaPointClick: gagal resolve bulan/tahun dari', monthLabel)
        setListPenggunaDetail([])
        return
      }

      setPenggunaPeriod({ thn: resolved.thn, bln: resolved.bln })

      const formData = new FormData()
      formData.append('jenis_periode', periode)
      formData.append('thn', resolved.thn)
      formData.append('bln', resolved.bln)
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)

      const response = await executePost(DETAILPENGGUNA, formData)
      if (response?.code !== 200) {
        console.error('detailChartPengguna:', response?.msg || response)
        setListPenggunaDetail([])
        return
      }
      const data = response?.data
      setListPenggunaDetail(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
      setListPenggunaDetail([])
    } finally {
      setLoadingListPengguna(false)
    }
  }

  const handleKunjunganPointClick = async (label: string, value: number, index: number) => {
    const monthLabel = getChartLabelAtIndex(labelsKunjungan, index, label)
    const displayLabel = formatChartPointDisplayLabel(monthLabel, tahunAkhir)
    setSelectedLabelKunjungan(displayLabel)
    setSelectedValueKunjungan(value)
    setShowModalKunjungan(true)
    setLoadingListKunjungan(true)
    setListKunjunganDetail([])
  
    try {
      if (!monthLabel) {
        console.warn('handleKunjunganPointClick: label kosong')
        return
      }
  
      const resolved = resolveMonthYearFromChartLabel(monthLabel, tahunAkhir)
      if (!resolved) {
        console.warn('handleKunjunganPointClick: gagal resolve bulan/tahun dari', monthLabel)
        return
      }

      setKunjunganPeriod({ thn: resolved.thn, bln: resolved.bln })
  
      const formData = new FormData()
      formData.append('jenis_periode', periode)   // 'bulan'
      formData.append('thn', resolved.thn)         // '2026'
      formData.append('bln', resolved.bln)         // '06'
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      appendMitraIds(formData, selectedMitra)      // id_mitra[]=7488, id_mitra[]=6955, ...
  
      const response = await executePost(DETAILKUNJUNGAN, formData)
      if (response?.code !== 200) {
        console.error('detailChartKunjungan:', response?.msg || response)
        return
      }
      setListKunjunganDetail(Array.isArray(response?.data) ? response.data : [])
    } catch (error) {
      console.error('Terjadi kesalahan:', error)
      setListKunjunganDetail([])
    } finally {
      setLoadingListKunjungan(false)
    }
  }

  const GetDataPenggunaTerbanyak = async () => {
    try {
      setLoadingDataPenggunaTerbanyak(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_kecamatan', idKecamatan)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(PENGGUNATERBANYAK, formData)
      const dataResponse = response?.data
      setPenggunaTerbanyak(dataResponse)
      setTabelPenggunaTerbanyak(dataResponse)
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    } finally {
      setLoadingDataPenggunaTerbanyak(false)
    }
  }

  // const GetDownloadPengguna = async () => {
  //   try {
  //     setLoadingDataPenggunaTerbanyak(true) // Set loading to true when fetching data

  //     const response = await executePost(DOWNLOADPENGGUNA)
  //     const dataResponse = response?.data
  //     // setPenggunaTerbanyak(dataResponse)
  //     setTabelDownloadPengguna(dataResponse)
  //     console.log('downloadPengguna', dataResponse);

  //   } catch (error) {
  //     console.error('Terjadi kesalahan', error)
  //   } finally {
  //     setLoadingDataPenggunaTerbanyak(false)
  //   }
  // }

  const GetDataDurasiTerlama = async () => {
    try {
      setLoadingDataDurasiTerlama(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_kecamatan', idKecamatan)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(DURASITERLAMA, formData)

      if (response && response.code === 200) {
        const dataResponse = response?.data
        setDurasiTerlama(dataResponse)
        setTabelDurasiTerlama(dataResponse)
      }
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    } finally {
      setLoadingDataDurasiTerlama(false)
    }
  }

  const GetDataKoleksiTerbacaTerbanyak = async () => {
    try {
      setLoadingDataKoleksiTerbacaTerbanyak(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_kecamatan', idKecamatan)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(KOLEKSITERBACATERBANYAK, formData)
      const dataResponse = response?.data
      setKoleksiTerbacaTerbanyak(dataResponse)
      setTabelKoleksiTerbacaTerbanyak(dataResponse)
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    } finally {
      setLoadingDataKoleksiTerbacaTerbanyak(false)
    }
  }

  const GetDataPembacaTerbanyak = async () => {
    try {
      setLoadingDataPembacaTerbanyak(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_kecamatan', idKecamatan)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(PEMBACATERBANYAK, formData)
      const dataResponse = response?.data
      setPembacaTerbanyak(dataResponse)
      setTabelPembacaTerbanyak(dataResponse)
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    } finally {
      setLoadingDataPembacaTerbanyak(false)
    }
  }

  const GetDataPengunjungTerbanyak = async () => {
    try {
      setLoadingPengunjungTerbanyak(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_kecamatan', idKecamatan)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(PENGUNJUNGTERBANYAK, formData)
      const dataResponse = response?.data
      setPengunjungTerbanyak(dataResponse)
      setTabelPengunjungTerbanyak(dataResponse)
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    } finally {
      setLoadingPengunjungTerbanyak(false)
    }
  }

  const GetDataJumlahPengunjung = async () => {
    try {
      setLoadingDataJumlahPengunjung(true) // Set loading to true when fetching data

      // const formData = new FormData()
      const response = await executePost(JUMLAHPENGUNJUNG)
      const data = response?.data?.jumlah_pengunjung
      const jumlahPengunjung = Number(data)
      setJumlahPengunjung(jumlahPengunjung)
    } finally {
      setLoadingDataJumlahPengunjung(false)
    }
  }

  const GetJumlahDurasiBaca = async () => {
    try {
      setLoadingJumlahDurasiBaca(true) // Set loading to true when fetching data

      // const formData = new FormData()

      const response = await executePost(JMLDURASIJAM)
      const data = response?.data?.total_durasi_jam
      setJumlahDurasi(data)
    } finally {
      setLoadingJumlahDurasiBaca(false)
    }
  }

  const GetJumlahKoleksiDibaca = async () => {
    try {
      setLoadingJumlahKoleksiDibaca(true) // Set loading to true when fetching data

      // const formData = new FormData()

      const response = await executePost(JMLKOLEKSIDIBACA)
      const data = response?.data?.jumlah_koleksi_dibaca
      const diBaca  = Number(data)
      setJumlahKoleksiDibaca(diBaca)
    } finally {
      setLoadingJumlahKoleksiDibaca(false)
    }
  }

  const GetJumlahPembaca = async () => {
    try {
      setLoadingJumlahPembaca(true) // Set loading to true when fetching data

      // const formData = new FormData()

      const response = await executePost(JMLPEMBACA)
      const data = response?.data?.jumlah_total_pembaca
      const dataPembaca = Number(data)
      setJumlahPembaca(dataPembaca)
    } finally {
      setLoadingJumlahPembaca(false)
    }
  }

  const GetDataKoleksiTerbanyak = async () => {
    try {
      setLoadingDataKoleksiTerbanyak(true) // Set loading to true when fetching data

      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_kecamatan', idKecamatan)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)

      const response = await executePost(KOLEKSITERBANYAK, formData)
      const data = response?.data
      setKoleksiTerbanyak(data)
      setTabelKoleksiTerbanyak(data)
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    } finally {
      setLoadingDataKoleksiTerbanyak(false)
    }
  }

  useEffect(() => {
    getPermintaanBuku()
  }, [searchParams, currentPage, perPage])

  const getPermintaanBuku = async (): Promise<void> => {
    try {
      setLoadingPermintaanBuku(true) // Set loading to true when fetching data
      const UID = localStorage.getItem('UID')
      const token = localStorage.getItem('token')

      const headers = {
        UID: UID,
        TOKEN: token,
      }

      const queryParams = {
        search: searchParams, // Pastikan variabel searchParams telah didefinisikan
        page: currentPage.toString(), // Pastikan variabel currentPage telah didefinisikan
        per_page: perPage.toString(), // Pastikan variabel perPage telah didefinisikan
        jenis_periode: periode, // Pastikan variabel periode telah didefinisikan
        bln_awal: periodeAwal, // Pastikan variabel periodeAwal telah didefinisikan
        bln_akhir: periodeAkhir, // Pastikan variabel periodeAkhir telah didefinisikan
        thn_awal: tahunAwal, // Pastikan variabel tahunAwal telah didefinisikan
        thn_akhir: tahunAkhir, // Pastikan variabel tahunAkhir telah didefinisikan
      }

      const url = `${PERMINTAANBUKU}?${new URLSearchParams(queryParams)}`

      const response = await methodGet(url, headers)

      const data = Array.isArray(response.data) ? response.data : []
      setPermintaanBuku(data)
      setTotalPage(response.total ? Math.ceil(response.total / perPage) : 0)
    } catch (error: any) {
      console.error(`Gagal mengambil data ${error.message}`)
      setPermintaanBuku([])
      setTotalPage(0)
    } finally {
      setLoadingPermintaanBuku(false) // Set loading to false after fetching data
    }
  }

  useEffect(() => {
    if (penggunaTerbanyak && penggunaTerbanyak.length > 0) {
      const labels = penggunaTerbanyak.map((data) => data.nama)
      const dataValues = penggunaTerbanyak.map((data) => data.total_pengguna)

      setChartData((prevChartData) => ({
        ...prevChartData,
        datasets: [
          {
            ...prevChartData.datasets[0],
            data: dataValues,
          },
        ],
        labels: labels,
      }))
    }
  }, [penggunaTerbanyak])

  useEffect(() => {
    if (durasiTerlama && durasiTerlama.length > 0) {
      const labels = durasiTerlama.map((data) => data.nama)
      const dataValues = durasiTerlama.map((data) => data.total_durasi_jam)

      setChartDataDurasiTerlama((prevChartData) => ({
        ...prevChartData,
        datasets: [
          {
            ...prevChartData.datasets[0],
            data: dataValues,
          },
        ],
        labels: labels,
      }))
    }
  }, [durasiTerlama])

  useEffect(() => {
    if (koleksiTerbacaTerbanyak && koleksiTerbacaTerbanyak.length > 0) {
      const labels = koleksiTerbacaTerbanyak.map((data) => data.nama)
      const dataValues = koleksiTerbacaTerbanyak.map((data) => data.jumlah_koleksi_dibaca)

      setchartDataKoleksiTerbacaTerbanyak((prevChartData) => ({
        ...prevChartData,
        datasets: [
          {
            ...prevChartData.datasets[0],
            data: dataValues,
          },
        ],
        labels: labels,
      }))
    }
  }, [koleksiTerbacaTerbanyak])

  useEffect(() => {
    if (pengunjungTerbanyak && pengunjungTerbanyak.length > 0) {
      const labels = pengunjungTerbanyak.map((data) => data.nama)
      const dataValues = pengunjungTerbanyak.map((data) => data.total_pengunjung)

      setChartDataPengunjungTerbanyak((prevChartData) => ({
        ...prevChartData,
        datasets: [
          {
            ...prevChartData.datasets[0],
            data: dataValues,
          },
        ],
        labels: labels,
      }))
    }
  }, [pengunjungTerbanyak])

  useEffect(() => {
    if (pembacaTerbanyak && pembacaTerbanyak.length > 0) {
      const labels = pembacaTerbanyak.map((data) => data.nama)
      const dataValues = pembacaTerbanyak.map((data) => data.jumlah_total_pembaca)

      setChartDataPembaca((prevChartData) => ({
        ...prevChartData,
        datasets: [
          {
            ...prevChartData.datasets[0],
            data: dataValues,
          },
        ],
        labels: labels,
      }))
    }
  }, [pembacaTerbanyak])

  useEffect(() => {
    if (koleksiTerbanyak && koleksiTerbanyak.length > 0) {
      const labels = koleksiTerbanyak.map((data) => data.nama)
      const dataValues = koleksiTerbanyak.map((data) => data.total_koleksi)

      setChartDataKoleksi((prevChartData) => ({
        ...prevChartData,
        datasets: [
          {
            ...prevChartData.datasets[0],
            data: dataValues,
          },
        ],
        labels: labels,
      }))
    }
  }, [koleksiTerbanyak])

  useEffect(() => {
    GetDataJumlahPerpus()
    GetDataJumlahPengguna()
    GetDataJumlahKoleksi()
    GetDataJumlahPengunjung()
    getDurasiBaca()
    getDurasiPengguna()
    // getDurasiKoleksi()
    getDurasiKunjungan()
    getDurasiPembaca()
    getDurasiKoleksiDibaca()
    GetDataPenggunaTerbanyak()
    GetDataKoleksiTerbacaTerbanyak()
    GetDataPengunjungTerbanyak()
    GetDataDurasiTerlama()
    GetDataKoleksiTerbanyak()
    GetDataPembacaTerbanyak()
    GetJumlahDurasiBaca()
    GetJumlahKoleksiDibaca()
    GetJumlahPembaca()
    // GetDownloadPengguna()
  }, [])

  // filter

  interface OptionType {
    value: string
    label: string
  }
  const tahun = getYearsRange(14)

  const getDataKota = async () => {
    try {
      const response = await executeGet(KOTA)
      const dataKota = response?.data || []
      const mappedDataKota = dataKota.map((kota) => ({
        value: String(kota.id),
        label: kota.nama,
      }))
      setSelectDataKota({ options: mappedDataKota })
      // console.log(dataKota);
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setLoading(false)
    }
  }

  const getDataJenjang = async () => {
    try {
      const response = await executeGet(JENJANG)
      const dataJenjang = response?.data || []
      const mappedDataJenjang = dataJenjang.map((jenjang) => ({
        value: String(jenjang.id),
        label: jenjang.nama,
      }))
      setSelectDataJenjang({ options: mappedDataJenjang })
      // console.log(dataJenjang);
    } catch (error) {
      console.error('Erorr fetching data: ', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchMitraOptions = async (term: string): Promise<FilterOption[]> => {
    const trimmed = term.trim()
    if (trimmed.length < 2) return []

    try {
      const formData = new FormData()
      formData.append('term', trimmed)
      const response = await executePost(GETMITRA, formData)
      const dataMitra = Array.isArray(response?.data) ? response.data : []

      return dataMitra.map((mitra: { id: number | string; nama?: string; name?: string }) => ({
        value: String(mitra.id),
        label: mitra.nama || mitra.name || '',
      }))
    } catch (error) {
      console.error('Error fetching data Mitra: ', error)
      return []
    }
  }

  const getDataKecamatan = async (idKota) => {
    try {
      const formData = new FormData()
      formData.append('id_kota', idKota)
      const response = await executePost(KECAMATAN, formData)
      const dataKecamatan = response?.data || []
      const mappedDataKecamatan = dataKecamatan.map((kecamatan) => ({
        value: String(kecamatan.id),
        label: kecamatan.name,
      }))
      setSelectDataKecamatan({ options: mappedDataKecamatan })
    } catch (error) {
      console.error('Error fetching data Kecamatan:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getDataKota()
    getDataJenjang()
    // getDataMitra()
  }, [])

  const handleKotaSelect = async (selectedOption: OptionType | null) => {
    try {
      if (selectedOption && selectedOption.value) {
        setIdKota(selectedOption.value)
        setNamakota(selectedOption.label)
        setIdKecamatan('')
        await getDataKecamatan(selectedOption.value) // Panggil getDataKecamatan dengan ID kota yang dipilih
        // Lakukan sesuatu dengan selectedOption.value di sini (jika diperlukan)
      } else {
        setIdKota('')
        setNamakota('')
        // console.error('Nilai selectedOption tidak valid.')
      }
    } catch (error) {
      console.error('Error handling selected city:', error)
    }
  }

  const handleKecamatanSelect = async (selectedOption: OptionType | null) => {
    try {
      if (selectedOption && selectedOption.value) {
        setIdKecamatan(selectedOption.value)
      } else {
        console.error('Nilai selectedOption tidak valid')
      }
    } catch (error) {
      console.error('Error handling selected kecamatan:', error)
    }
  }

  const handleJenjangSelect = async (selectedOption: OptionType | null) => {
    try {
      if (selectedOption && selectedOption.value) {
        setIdJenjang(selectedOption.value)
        setNamaJenjang(selectedOption.label)
      } else {
        setIdJenjang('')
        setNamaJenjang('')
        // console.error('Nilai selectedOption tidak valid')
      }
    } catch (error) {
      console.error('Error handling selected jenjang: ', error)
    }
  }

  const handleMitraSelect = (selected: MultiValue<FilterOption>) => {
    setSelectedMitra(selected ? [...selected] : [])
  }

  const handlePeriodeChange = (
    newValue: StateOption | null,
    actionMeta: ActionMeta<StateOption>
  ) => {
    if (newValue && newValue.value) {
      setPeriode(newValue.value)

      if (newValue.value.toLowerCase() === 'tahun') {
        setPeriodeAwal('')
        setPeriodeAkhir('')
        setShowPeriodeAwalAkhir(false)
      } else {
        setBulanAwal('Januari')
        setBulanAkhir('Desember')
        setPeriodeAwal('01')
        setPeriodeAkhir('12')
        setShowPeriodeAwalAkhir(true)
      }
    }
  }

  const handlePeriodeAwal = (selectedOption: StateOption | null) => {
    if (selectedOption && selectedOption.value) {
      setPeriodeAwal(selectedOption.value)
      setBulanAwal(selectedOption.label)
    }
  }

  const handlePeriodeAkhir = (selectedOptions: StateOption | null) => {
    if (selectedOptions && selectedOptions.value) {
      setPeriodeAkhir(selectedOptions.value)
      setBulanAkhir(selectedOptions.label)
    }
  }

  const handleTahunAwal = (selectedOption: StateOption | null) => {
    if (selectedOption && selectedOption.value) {
      setTahunAwal(selectedOption.value)
    }
  }

  const handleTahunAkhir = (selectedOption: StateOption | null) => {
    if (selectedOption && selectedOption.value) {
      setTahunAkhir(selectedOption.value)
    }
  }
  const [kota, setKota] = useState('')
  const [jenjang, setJenjang] = useState('')
  const [mitra, setMitra] = useState('')
  const [filterFormKey, setFilterFormKey] = useState(0)
  const [resetCounter, setResetCounter] = useState(0)

  const handleFilterExpandEntered = () => {
    manualExpandRef.current = false
    lastScrollY.current = window.scrollY
    ignoreCollapseUntil.current = Date.now() + 500
  }

  const fetchAllDashboardData = () => {
    GetDataJumlahPerpus()
    GetDataJumlahPengunjung()
    GetDataJumlahPengguna()
    GetDataJumlahKoleksi()
    getDurasiBaca()
    getDurasiPengguna()
    // getDurasiKoleksi()
    getDurasiKunjungan()
    getDurasiPembaca()
    getDurasiKoleksiDibaca()
    GetDataPenggunaTerbanyak()
    GetDataKoleksiTerbacaTerbanyak()
    GetDataPengunjungTerbanyak()
    GetDataDurasiTerlama()
    GetDataKoleksiTerbanyak()
    GetDataPembacaTerbanyak()
    GetJumlahDurasiBaca()
    GetJumlahKoleksiDibaca()
    GetJumlahPembaca()
    getPermintaanBuku()
  }

  const handleButtonClick = async () => {
    try {
      fetchAllDashboardData()
      setKota(namaKota)
      setJenjang(namaJenjang)
      setMitra(
        selectedMitra.length === 0
          ? ''
          : selectedMitra.map((item) => item.label).join(', ')
      )
      setIsFilterExpanded(false)
      manualExpandRef.current = false
      ignoreCollapseUntil.current = Date.now() + 800
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Filter diterapkan',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      })
    } catch (error) {
      console.error('Error handling button click:', error)
    }
  }

  const handleResetFilter = () => {
    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const monthStr = currentMonth < 10 ? `0${currentMonth}` : String(currentMonth)

    setIdKota('')
    setNamakota('')
    setIdKecamatan('')
    setIdJenjang('')
    setNamaJenjang('')
    setSelectedMitra([])
    setPeriode('bulan')
    setShowPeriodeAwalAkhir(true)
    setPeriodeAwal('01')
    setPeriodeAkhir(monthStr)
    setBulanAwal('Januari')
    setBulanAkhir(bulan[currentMonth])
    setTahunAwal(String(now.getFullYear()))
    setTahunAkhir(String(now.getFullYear()))
    setKota('')
    setJenjang('')
    setMitra('')
    setFilterFormKey((k) => k + 1)
    setResetCounter((c) => c + 1)
  }

  useEffect(() => {
    if (resetCounter === 0) return

    fetchAllDashboardData()
    setIsFilterExpanded(false)
    manualExpandRef.current = false
    ignoreCollapseUntil.current = Date.now() + 800
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'info',
      title: 'Filter direset',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    })
  }, [resetCounter])

  const formattedJumlahPengguna = jumlahPengguna !== undefined ? jumlahPengguna.toLocaleString('id-ID') : '';
  const formattedJumlahKoleksi = jumlahKoleksi !== undefined ? jumlahKoleksi.toLocaleString('id-ID') : '';
  const formattedJumlahPengunjung = jumlahPengunjung!== undefined? jumlahPengunjung.toLocaleString('id-ID') : '';
  const formattedJumlahPembaca = jumlahPembaca!== undefined? jumlahPembaca.toLocaleString('id-ID') : '';
  const formattedJumlahKoleksiDibaca = jumlahKoleksiDibaca!== undefined? jumlahKoleksiDibaca.toLocaleString('id-ID') : '';

  const activeFilterSummary = useMemo(() => {
    const periodeLabel = periodeOptions.find((o) => o.value === periode)?.label ?? periode
    const rentang = `${bulanAwal} ${tahunAwal} – ${bulanAkhir} ${tahunAkhir}`
    return {
      periodeLabel,
      rentang,
      kotaLabel: kota || 'Semua Kota',
      jenjangLabel: jenjang || 'Semua Jenjang',
      mitraLabel: mitra || null,
    }
  }, [kota, jenjang, mitra, periode, bulanAwal, tahunAwal, bulanAkhir, tahunAkhir])

  return (
    <>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-6'>
          <TilesWidget2
            className='card-xl-stretch mb-5 mb-xl-8'
            jumlah={jumlahPerpus}
            loading={loadingJumlahPerpus}
          />
          <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8'>
            <div className='col-xl-6'>
              <TilesWidget5
                loading={loadingJumlahPengguna}
                className='card-xxl-stretch bg-success'
                svgIcon='user'
                titleClass='text-light'
                descriptionClass='text-light'
                iconClass='text-light'
                title={formattedJumlahPengguna}
                description='JUMLAH PENGGUNA'
              />
            </div>
            <div className='col-xl-6'>
              <TilesWidget5
                className='card-xxl-stretch bg-warning '
                svgIcon='book'
                titleClass='text-light'
                descriptionClass='text-light'
                iconClass='text-light'
                title={formattedJumlahKoleksi}
                description='JUMLAH KOLEKSI BUKU'
                loading={loadingJumlahKoleksi}
              />
            </div>
          </div>
        </div>
        <div className='col-xl-6'>
          <div className='row gx-5 gx-xl-8 mb-5 mb-xl-14 '>
            <div className='col-xl-6 '>
              <TilesWidget5
                className='card-xxl-stretch bg-dark'
                svgIcon='timer'
                titleClass='text-light'
                descriptionClass='text-light'
                iconClass='text-light'
                title={jumlahDurasi ? jumlahDurasi.toString() : ''}
                description='JUMLAH DURASI JAM'
                loading={loadingJumlahDurasiBaca}
              />
            </div>
            <div className='col-xl-6'>
              <TilesWidget5
                className='card-xxl-stretch bg-primary'
                svgIcon='book-open'
                titleClass='text-light'
                descriptionClass='text-light'
                iconClass='text-light'
                title={formattedJumlahKoleksiDibaca}
                description='JUMLAH KOLEKSI TERBACA'
                loading={loadingJumlahKoleksiDibaca}
              />
            </div>
          </div>
          <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8'>
            <div className='col-xl-6'>
              <TilesWidget5
                className='card-xxl-stretch bg-info'
                svgIcon='chart-pie-3'
                titleClass='text-light'
                descriptionClass='text-light'
                iconClass='text-light'
                title={formattedJumlahPengunjung}
                description='JUMLAH KUNJUNGAN'
                loading={loadingDataJumlahPengunjung}
              />
            </div>
            <div className='col-xl-6'>
              <TilesWidget5
                className='card-xxl-stretch bg-danger'
                svgIcon='user-tick'
                titleClass='text-light'
                descriptionClass='text-light'
                iconClass='text-light'
                title={formattedJumlahPembaca}
                description='JUMLAH PEMBACA'
                loading={loadingJumlahPembaca}
              />
            </div>
          </div>
        </div>

        {/* <Separator/> */}

        <Modal
          show={showModalKoleksiDibaca}
          onHide={closeModalKoleksiDibaca}
          size='xl'
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Koleksi Dibaca — {selectedLabelKoleksiDibaca} ({selectedValueKoleksiDibaca})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered table-striped'>
                <thead className='table-dark'>
                  <tr>
                    <th>Mitra / Supplier</th>
                    <th>Jumlah Koleksi Dibaca</th>
                    <th className='text-center' style={{ width: '100px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingListKoleksiDibaca ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        <Spinner animation='border' role='status' />
                      </td>
                    </tr>
                  ) : listKoleksiDibacaDetail.length === 0 ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        Tidak ada data
                      </td>
                    </tr>
                  ) : (
                    listKoleksiDibacaDetail.map((item, index) => (
                      <tr key={item.id_mitra || index}>
                        <td>{item.nama || '-'}</td>
                        <td>
                          {item.jumlah_koleksi_dibaca !== undefined
                            ? Number(item.jumlah_koleksi_dibaca).toLocaleString('id-ID')
                            : item.jumlah !== undefined
                              ? Number(item.jumlah).toLocaleString('id-ID')
                              : '-'}
                        </td>
                        <td className='text-center'>
                          {item.id_mitra ? (
                            <Button
                              variant='light-primary'
                              size='sm'
                              className='btn btn-sm btn-light-primary'
                              onClick={() => handleKoleksiMitraClick(item)}
                            >
                              Detail
                            </Button>
                          ) : (
                            '-'
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {renderDetailDownloadButton(
              'koleksiDibaca',
              handleDownloadKoleksiDibacaDetail,
              loadingListKoleksiDibaca
            )}
            <Button variant='secondary' onClick={closeModalKoleksiDibaca}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModalKontenPerMitra}
          onHide={() => setShowModalKontenPerMitra(false)}
          size='xl'
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Konten Dibaca — {selectedMitraKoleksi?.nama} — {selectedLabelKoleksiDibaca}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='p-3'>
            <div className='table-responsive' style={{ height: '350px', overflowY: 'auto' }}>
              <table className='table table-hover table-bordered table-striped mb-0'>
                <thead className='table-dark'>
                  <tr>
                    <th>No</th>
                    <th>Judul Buku</th>
                    <th>Jumlah Konten Dibaca</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingKontenPerMitra ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        <Spinner animation='border' role='status' />
                      </td>
                    </tr>
                  ) : listKontenPerMitra.length === 0 ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        Tidak ada data
                      </td>
                    </tr>
                  ) : (
                    listKontenPerMitra.map((book, index) => (
                      <tr key={book.id_konten || index}>
                        <td>{index + 1}</td>
                        <td>{book.judul || book.nama || '-'}</td>
                        <td className='text-end'>
                          {book.jumlah_dibaca !== undefined
                            ? Number(book.jumlah_dibaca).toLocaleString('id-ID')
                            : book.jumlah !== undefined
                              ? Number(book.jumlah).toLocaleString('id-ID')
                              : book.jumlah_konten_dibaca !== undefined
                                ? Number(book.jumlah_konten_dibaca).toLocaleString('id-ID')
                                : '-'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {renderDetailDownloadButton(
              'kontenPerMitra',
              handleDownloadKontenPerMitra,
              loadingKontenPerMitra
            )}
            <Button variant='secondary' onClick={() => setShowModalKontenPerMitra(false)}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModalPembaca}
          onHide={() => {
            setShowModalPembaca(false)
            setPembacaPeriod(null)
          }}
          size='xl'
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Pembaca — {selectedLabelPembaca} ({selectedValuePembaca})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered table-striped'>
                <thead className='table-dark'>
                  <tr>
                    <th>Mitra / Supplier</th>
                    <th>Jumlah Pembaca</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingListPembaca ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        <Spinner animation='border' role='status' />
                      </td>
                    </tr>
                  ) : listPembacaDetail.length === 0 ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        Tidak ada data
                      </td>
                    </tr>
                  ) : (
                    listPembacaDetail.map((item, index) => (
                      <tr key={item.id_mitra || index}>
                        <td>{item.nama || '-'}</td>                        
                        <td>
                          {item.jumlah_total_pembaca !== undefined
                            ? Number(item.jumlah_total_pembaca).toLocaleString('id-ID')
                            : item.jumlah !== undefined
                              ? Number(item.jumlah).toLocaleString('id-ID')
                              : '-'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {renderDetailDownloadButton('pembaca', handleDownloadPembacaDetail, loadingListPembaca)}
            <Button
              variant='secondary'
              onClick={() => {
                setShowModalPembaca(false)
                setPembacaPeriod(null)
              }}
            >
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModalDurasiBaca}
          onHide={() => {
            setShowModalDurasiBaca(false)
            setDurasiPeriod(null)
          }}
          size='xl'
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Durasi Baca — {selectedLabelDurasiBaca} ({formatDurasiJam(selectedValueDurasiBaca)})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered table-striped'>
                <thead className='table-dark'>
                  <tr>
                    <th>Mitra / Supplier</th>
                    <th>Durasi</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingListDurasiBaca ? (
                    <tr>
                      <td colSpan={2} className='text-center'>
                        <Spinner animation='border' role='status' />
                      </td>
                    </tr>
                  ) : listDurasiBacaDetail.length === 0 ? (
                    <tr>
                      <td colSpan={2} className='text-center'>
                        Tidak ada data
                      </td>
                    </tr>
                  ) : (
                    listDurasiBacaDetail.map((item, index) => (
                      <tr key={item.id_mitra || index}>
                        <td>{item.nama || '-'}</td>
                        <td>
                          {formatDurasiJam(item.jumlah ?? item.durasi_jam_convert ?? item.total_durasi_jam)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {renderDetailDownloadButton('durasi', handleDownloadDurasiDetail, loadingListDurasiBaca)}
            <Button
              variant='secondary'
              onClick={() => {
                setShowModalDurasiBaca(false)
                setDurasiPeriod(null)
              }}
            >
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModalPengguna}
          onHide={() => {
            setShowModalPengguna(false)
            setPenggunaPeriod(null)
          }}
          size='xl'
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Pengguna — {selectedLabelPengguna} ({selectedValuePengguna})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered table-striped'>
                <thead className='table-dark'>
                  <tr>
                    <th>Mitra / Supplier</th>
                    <th>Jumlah Pengguna</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingListPengguna ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        <Spinner animation='border' role='status' />
                      </td>
                    </tr>
                  ) : listPenggunaDetail.length === 0 ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        Tidak ada data
                      </td>
                    </tr>
                  ) : (
                    listPenggunaDetail.map((item, index) => (
                      <tr key={item.id_mitra || index}>
                        <td>{item.nama || '-'}</td>
                        <td>
                          {item.total_pengguna !== undefined
                            ? Number(item.total_pengguna).toLocaleString('id-ID')
                            : item.jumlah_total_pengguna !== undefined
                              ? Number(item.jumlah_total_pengguna).toLocaleString('id-ID')
                              : item.jumlah !== undefined
                                ? Number(item.jumlah).toLocaleString('id-ID')
                                : '-'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {renderDetailDownloadButton(
              'pengguna',
              handleDownloadPenggunaDetail,
              loadingListPengguna
            )}
            <Button
              variant='secondary'
              onClick={() => {
                setShowModalPengguna(false)
                setPenggunaPeriod(null)
              }}
            >
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModalKunjungan}
          onHide={() => {
            setShowModalKunjungan(false)
            setKunjunganPeriod(null)
          }}
          size='xl'
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Kunjungan — {selectedLabelKunjungan} ({selectedValueKunjungan})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered table-striped'>
                <thead className='table-dark'>
                  <tr>
                    <th>Mitra / Supplier</th>
                    <th>Jumlah Kunjungan</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingListKunjungan ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        <Spinner animation='border' role='status' />
                      </td>
                    </tr>
                  ) : listKunjunganDetail.length === 0 ? (
                    <tr>
                      <td colSpan={3} className='text-center'>
                        Tidak ada data
                      </td>
                    </tr>
                  ) : (
                    listKunjunganDetail.map((item, index) => (
                      <tr key={item.id_mitra || index}>
                        <td>{item.nama || '-'}</td>
                        <td>
                          {item.total_kunjungan !== undefined
                            ? Number(item.total_kunjungan).toLocaleString('id-ID')
                            : item.jumlah !== undefined
                              ? Number(item.jumlah).toLocaleString('id-ID')
                              : '-'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {renderDetailDownloadButton(
              'kunjungan',
              handleDownloadKunjunganDetail,
              loadingListKunjungan
            )}
            <Button
              variant='secondary'
              onClick={() => {
                setShowModalKunjungan(false)
                setKunjunganPeriod(null)
              }}
            >
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ================= FILTER HEADER ================= */}
        <div ref={sentinelRef} aria-hidden='true' style={{ height: 1 }} />
        <div
          ref={filterRef}
          className='col-xl-12'
          style={{ position: 'sticky', top: stickyTop, zIndex: 104 }}
        >
        <div
          className={`card card-xl-stretch mb-5 mb-xl-8 ${
            isFilterStuck ? 'shadow-lg' : 'shadow-sm'
          }`}
          style={{ backgroundColor: 'var(--bs-body-bg, #ffffff)' }}
        >
          <div className='card-body p-7'>

            {/* Header */}
            <div
              className={`d-flex justify-content-between align-items-center ${
                isFilterExpanded ? 'mb-7' : 'mb-0'
              }`}
            >
              <div className='d-flex align-items-center'>
                <div
                  className='d-flex align-items-center justify-content-center rounded-3'
                  style={{
                    width: '46px',
                    height: '46px',
                    backgroundColor: 'rgba(54, 153, 255, 0.1)',
                  }}
                >
                  <i className='bi bi-funnel-fill fs-2 text-primary'></i>
                </div>

                <div className='ms-4'>
                  <h3 className='fw-bold text-gray-800 mb-1'>
                    Filter Data
                  </h3>

                  <span className='text-gray-500 fs-7'>
                    Atur parameter untuk menampilkan data perpustakaan
                  </span>
                </div>
              </div>

              <div className='d-flex align-items-center gap-3 ms-4 flex-grow-1 justify-content-end min-w-0'>
                {!isFilterExpanded && (
                  <div className='d-flex flex-wrap align-items-center gap-2 justify-content-end min-w-0'>
                    <span className='badge badge-light-primary fs-8 fw-semibold'>
                      {activeFilterSummary.periodeLabel}
                    </span>
                    <span className='badge badge-light fs-8 text-gray-700'>
                      {activeFilterSummary.rentang}
                    </span>
                    <span className='badge badge-light fs-8 text-gray-700'>
                      {activeFilterSummary.kotaLabel}
                    </span>
                    <span className='badge badge-light fs-8 text-gray-700'>
                      {activeFilterSummary.jenjangLabel}
                    </span>
                    {activeFilterSummary.mitraLabel && (
                      <span
                        className='badge badge-light fs-8 text-gray-700 text-truncate'
                        style={{ maxWidth: '220px' }}
                        title={activeFilterSummary.mitraLabel}
                      >
                        {activeFilterSummary.mitraLabel}
                      </span>
                    )}
                  </div>
                )}

                <div
                  className='d-flex align-items-center justify-content-center rounded-circle flex-shrink-0'
                  style={{
                    width: '36px',
                    height: '36px',
                    backgroundColor: toggleHover ? '#eef3f7' : '#f5f8fa',
                    cursor: 'pointer',
                    transition: 'background-color 0.15s ease',
                  }}
                  onMouseEnter={() => setToggleHover(true)}
                  onMouseLeave={() => setToggleHover(false)}
                  onClick={(e) => {
                    e.stopPropagation()
                    setIsFilterExpanded((prev) => {
                      if (!prev) {
                        manualExpandRef.current = true
                        ignoreCollapseUntil.current = Date.now() + 800
                        lastScrollY.current = window.scrollY
                      } else {
                        manualExpandRef.current = false
                      }
                      return !prev
                    })
                  }}
                  role='button'
                  aria-expanded={isFilterExpanded}
                  aria-label={isFilterExpanded ? 'Sembunyikan filter' : 'Tampilkan filter'}
                >
                  <i
                    className={`bi ${
                      isFilterExpanded ? 'bi-chevron-up' : 'bi-chevron-down'
                    } fs-5 text-gray-600`}
                  ></i>
                </div>
              </div>
            </div>

            <Collapse in={isFilterExpanded} onEntered={handleFilterExpandEntered}>
              <div>
                <div
                  key={filterFormKey}
                  className='filter-expanded-panel pe-1'
                  style={{
                    maxHeight: `calc(100dvh - ${stickyTop + 200}px)`,
                    overflowY: 'auto',
                    overscrollBehavior: 'contain',
                  }}
                >
            {/* ================= LOKASI + PERIODE ================= */}
            <div className='row g-5 mb-5'>

              {/* ================================================== */}
              {/* CARD LOKASI */}
              {/* ================================================== */}
              <div className='col-xl-6'>
                <div className='border border-gray-200 rounded-3 h-100 p-6'>

                  {/* Header Lokasi */}
                  <div className='d-flex align-items-center mb-6'>
                    <div
                      className='d-flex align-items-center justify-content-center rounded-2 me-3'
                      style={{
                        width: '38px',
                        height: '38px',
                        backgroundColor: 'rgba(54, 153, 255, 0.1)',
                      }}
                    >
                      <i className='bi bi-geo-alt-fill text-primary fs-5'></i>
                    </div>

                    <div>
                      <h5 className='fw-bold text-gray-800 mb-0'>
                        Lokasi
                      </h5>

                      <span className='text-gray-500 fs-8'>
                        Tentukan lokasi perpustakaan
                      </span>
                    </div>
                  </div>

                  {/* Filter Lokasi */}
                  <div>

                    {/* Kota */}
                    <div className='mb-5'>
                      <label className='form-label fw-semibold text-gray-700 mb-2'>
                        Kota
                      </label>

                      <CreatableSelect
                        isClearable
                        options={selectDataKota.options}
                        onChange={handleKotaSelect}
                        placeholder='Pilih Kota'
                      />
                    </div>

                    {/* Jenjang */}
                    <div className='mb-5'>
                      <label className='form-label fw-semibold text-gray-700 mb-2'>
                        Jenjang
                      </label>

                      <CreatableSelect
                        isClearable
                        options={selectDataJenjang.options}
                        onChange={handleJenjangSelect}
                        placeholder='Pilih Jenjang'
                      />
                    </div>

                    {/* Mitra */}
                    <div>
                      <label className='form-label fw-semibold text-gray-700 mb-2'>
                        Mitra
                      </label>
                      <span className='text-muted fs-8 d-block mb-2'>
                        Hanya memengaruhi grafik line chart (statistik tren). Pie chart tidak
                        terfilter by mitra.
                      </span>

                      <AsyncCreatableSelect
                        isMulti
                        isClearable
                        cacheOptions
                        defaultOptions={false}
                        loadOptions={fetchMitraOptions}
                        value={selectedMitra}
                        onChange={handleMitraSelect}
                        placeholder='Ketik minimal 2 karakter'
                        noOptionsMessage={({ inputValue }) =>
                          inputValue.trim().length < 2
                            ? 'Ketik minimal 2 karakter'
                            : 'Tidak ada data'
                        }
                        loadingMessage={() => 'Mencari...'}
                        isValidNewOption={() => false}
                      />
                    </div>

                  </div>

                </div>
              </div>


              {/* ================================================== */}
              {/* CARD PERIODE */}
              {/* ================================================== */}
              <div className='col-xl-6'>
                <div className='border border-gray-200 rounded-3 h-100 p-6'>

                  {/* Header Periode */}
                  <div className='d-flex align-items-center mb-6'>
                    <div
                      className='d-flex align-items-center justify-content-center rounded-2 me-3'
                      style={{
                        width: '38px',
                        height: '38px',
                        backgroundColor: 'rgba(54, 153, 255, 0.1)',
                      }}
                    >
                      <i className='bi bi-calendar3 text-primary fs-5'></i>
                    </div>

                    <div>
                      <h5 className='fw-bold text-gray-800 mb-0'>
                        Periode
                      </h5>

                      <span className='text-gray-500 fs-8'>
                        Tentukan rentang periode data
                      </span>
                    </div>
                  </div>

                  {/* Filter Periode */}
                  <div>

                    {/* Jenis Periode */}
                    <div className='mb-5'>
                      <label className='form-label fw-semibold text-gray-700 mb-2'>
                        Jenis Periode
                      </label>

                      <CreatableSelect
                        options={periodeOptions}
                        onChange={handlePeriodeChange}
                        defaultValue={periodeOptions.find(
                          (option) => option.value === periode
                        )}
                        placeholder='Pilih periode'
                      />
                    </div>

                    {/* Periode Awal */}
                    {showPeriodeAwalAkhir && (
                      <div className='mb-5'>
                        <label className='form-label fw-semibold text-gray-700 mb-2'>
                          Periode Awal
                        </label>

                        <CreatableSelect
                          isClearable
                          options={monthOptions}
                          defaultValue={monthOptions.find(
                            (option) => option.value === periodeAwal
                          )}
                          onChange={handlePeriodeAwal}
                          placeholder='Pilih bulan'
                        />
                      </div>
                    )}

                    {/* Periode Akhir */}
                    {showPeriodeAwalAkhir && (
                      <div>
                        <label className='form-label fw-semibold text-gray-700 mb-2'>
                          Periode Akhir
                        </label>

                        <CreatableSelect
                          isClearable
                          options={monthOptions}
                          defaultValue={monthOptions.find(
                            (option) => option.value === periodeAkhir
                          )}
                          onChange={handlePeriodeAkhir}
                          placeholder='Pilih bulan'
                        />
                      </div>
                    )}

                  </div>

                </div>
              </div>

            </div>


            {/* ================================================== */}
            {/* CARD TAHUN - FULL WIDTH */}
            {/* ================================================== */}
            <div className='row mb-6'>
              <div className='col-xl-12'>

                <div className='border border-gray-200 rounded-3 p-6'>

                  {/* Header Tahun */}
                  <div className='d-flex align-items-center mb-6'>
                    <div
                      className='d-flex align-items-center justify-content-center rounded-2 me-3'
                      style={{
                        width: '38px',
                        height: '38px',
                        backgroundColor: 'rgba(54, 153, 255, 0.1)',
                      }}
                    >
                      <i className='bi bi-calendar-range text-primary fs-5'></i>
                    </div>

                    <div>
                      <h5 className='fw-bold text-gray-800 mb-0'>
                        Tahun
                      </h5>

                      <span className='text-gray-500 fs-8'>
                        Tentukan rentang tahun data
                      </span>
                    </div>
                  </div>

                  {/* Filter Tahun */}
                  <div className='row g-5'>

                    {/* Tahun Awal */}
                    <div className='col-md-6'>
                      <label className='form-label fw-semibold text-gray-700 mb-2'>
                        Tahun Awal
                      </label>

                      <CreatableSelect
                        isClearable
                        options={tahun}
                        defaultValue={tahun.find(
                          (option) => option.value === tahunAwal
                        )}
                        onChange={handleTahunAwal}
                        placeholder='Pilih tahun'
                      />
                    </div>

                    {/* Tahun Akhir */}
                    <div className='col-md-6'>
                      <label className='form-label fw-semibold text-gray-700 mb-2'>
                        Tahun Akhir
                      </label>

                      <CreatableSelect
                        isClearable
                        options={tahun}
                        defaultValue={tahun.find(
                          (option) => option.value === tahunAkhir
                        )}
                        onChange={handleTahunAkhir}
                        placeholder='Pilih tahun'
                      />
                    </div>

                  </div>

                </div>

              </div>
            </div>
                </div>

            {/* ================================================== */}
            {/* FOOTER — di luar area scroll agar tombol selalu terlihat */}
            {/* ================================================== */}
            <div className='separator my-5'></div>

            <div
              className='d-flex justify-content-end gap-3 flex-wrap pb-1'
              style={{
                position: 'sticky',
                bottom: 0,
                backgroundColor: 'var(--bs-body-bg, #ffffff)',
                zIndex: 1,
              }}
            >
              <Button
                variant='light'
                className='d-flex align-items-center px-7 py-3'
                onClick={handleResetFilter}
              >
                <i className='bi bi-arrow-counterclockwise me-2'></i>
                Reset Filter
              </Button>
              <Button
                variant='primary'
                className='d-flex align-items-center px-7 py-3'
                onClick={handleButtonClick}
              >
                <i className='bi bi-funnel-fill me-2'></i>
                Terapkan Filter
              </Button>
            </div>
              </div>
            </Collapse>

          </div>
        </div>
        </div>          

        <div className='col-xl-12'>
          <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
            <div className='card-body d-flex flex-column justify-content-between'>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                10 PERPUSTAKAAN TERATAS BERDASARKAN JUMLAH PENGGUNA
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Di {kota === '' ? 'Semua Kota' : kota},{' '}
                {jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang}
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
              </h2>
              <div className='row d-flex justify-content-center align-items-center'>
                <div className='col-xl-6'>
                  {!penggunaTerbanyak || penggunaTerbanyak.length === 0 ? (
                    <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            <div className='table-responsive'>
                              <div className='alert alert-danger text-center' role='alert'>
                                {loadingDataPenggunaTerbanyak ? (
                                  <div className='d-flex align-items-center justify-content-center'>
                                    <Spinner animation='border' role='status' /> <br />
                                  </div>
                                ) : (
                                  <div>TIDAK ADA DATA</div>
                                )}{' '}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`card card-xl-stretch mb-5 mb-xl-8`}
                      style={{ backgroundColor: '#efefef' }}
                    >
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            {loadingDataPenggunaTerbanyak ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' role='status' /> <br />
                              </div>
                            ) : chartData && chartData.labels.length > 0 ? (
                              <JumlahPengguna chartData={chartData} />
                            ) : (
                              <div className='alert alert-danger text-center'>Tidak ada data</div>
                            )}
                          </div>
                        </>
                      </div>
                    </div>
                  )}
                </div>
                <div className='col-xl-6'>
                  <TablesWidget10
                    kota={kota}
                    jenjang={jenjang}
                    idJenjang={idJenjang}
                    idKota={idKota}
                    periode={periode}
                    periodeAwal={periodeAwal}
                    periodeAkhir={periodeAkhir}
                    bulanAwal={bulanAwal}
                    bulanAkhir={bulanAkhir}
                    tahunAwal={tahunAwal}
                    tahunAkhir={tahunAkhir}
                    svgIcon='cloud-download'
                    loading={loadingDataPenggunaTerbanyak}
                    tabelPenggunaTerbanyak={tabelPenggunaTerbanyak}
                    className='card-xxl-stretch mb-5 mb-xl-8'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-xl-12'>
          <div className='card card-xl-strech mb-5 mb-xl-8'>
            <div className='card-body d-flex flex-column justify-content-between'>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                10 PERPUSTAKAAN TERATAS BERDASARKAN KOLEKSI TERBANYAK
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Di {kota === '' ? 'Semua Kota' : kota},{' '}
                {jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang}
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
              </h2>
              <div className='row d-flex justify-content-center align-items-center'>
                {!koleksiTerbanyak || koleksiTerbanyak.length === 0 ? (
                  <div className='col-xl-6'>
                    <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            <div className='table-responsive'>
                              <div className='alert alert-danger text-center' role='alert'>
                                {loadingDataKoleksiTerbanyak ? (
                                  <div className='d-flex align-items-center justify-content-center'>
                                    <Spinner animation='border' role='status' /> <br />
                                  </div>
                                ) : (
                                  <div>TIDAK ADA DATA</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='col-xl-6'>
                    <div
                      className={`card card-xl-stretch mb-5 mb-xl-8`}
                      style={{ backgroundColor: '#efefef' }}
                    >
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            {loadingDataKoleksiTerbanyak ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' role='status' /> <br />
                              </div>
                            ) : chartDataKoleksi && chartDataKoleksi.labels.length > 0 ? (
                              <JumlahKoleksiBukuPie chartData={chartDataKoleksi} />
                            ) : (
                              <div className='alert alert-danger text-center'>Tidak ada data</div>
                            )}
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                )}
                <div className='col-xl-6'>
                  <TablesWidget14
                    kota={kota}
                    jenjang={jenjang}
                    idJenjang={idJenjang}
                    idKota={idKota}
                    periode={periode}
                    periodeAwal={periodeAwal}
                    periodeAkhir={periodeAkhir}
                    bulanAwal={bulanAwal}
                    bulanAkhir={bulanAkhir}
                    tahunAwal={tahunAwal}
                    tahunAkhir={tahunAkhir}
                    svgIcon='cloud-download'
                    loading={loadingDataKoleksiTerbanyak}
                    tabelKoleksiTebanyak={tabelKoleksiTebanyak}
                    className='card-xxl-stretch mb-5 mb-xl-8'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-xl-12'>
          <div className='card card-xl-strech mb-5 mb-xl-8'>
            <div className='card-body d-flex flex-column justify-content-between'>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                10 PERPUSTAKAAN TERATAS BERDASARKAN PEMBACA TERBANYAK
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Di {kota === '' ? 'Semua Kota' : kota},{' '}
                {jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang}
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
              </h2>
              <div className='row d-flex justify-content-center align-items-center'>
                {!pembacaTerbanyak || pembacaTerbanyak.length === 0 ? (
                  <div className='col-xl-6'>
                    <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            <div className='table-responsive'>
                              <div className='alert alert-danger text-center' role='alert'>
                                {loading ? (
                                  <div className='d-flex align-items-center justify-content-center'>
                                    <Spinner animation='border' role='status' /> <br />
                                  </div>
                                ) : (
                                  <div>TIDAK ADA DATA</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='col-xl-6'>
                    <div
                      className={`card card-xl-stretch mb-5 mb-xl-8`}
                      style={{ backgroundColor: '#efefef' }}
                    >
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <h2 className='text-dark fw-bold mb-5 text-center'>
                            10 PERPUSTAKAAN TERATAS
                          </h2>
                          <h2 className='text-dark fw-bold mb-5 text-center'>
                            BERDASARKAN PEMBACA TERBANYAK
                          </h2>
                          <div className='m-100'>
                            {loadingDataPembacaTerbanyak ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' role='status' /> <br />
                              </div>
                            ) : chartDataPembaca && chartDataPembaca.labels.length > 0 ? (
                              <JumlahPembaca chartDataPembaca={chartDataPembaca} />
                            ) : (
                              <div className='alert alert-danger text-center'>Tidak ada data</div>
                            )}
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                )}
                <div className='col-xl-6'>
                  <TablesWidjetPembaca
                    kota={kota}
                    jenjang={jenjang}
                    idJenjang={idJenjang}
                    idKota={idKota}
                    periode={periode}
                    periodeAwal={periodeAwal}
                    periodeAkhir={periodeAkhir}
                    bulanAwal={bulanAwal}
                    bulanAkhir={bulanAkhir}
                    tahunAwal={tahunAwal}
                    tahunAkhir={tahunAkhir}
                    svgIcon='cloud-download'
                    loading={loadingDataPembacaTerbanyak}
                    tabelPembacaTerbanyak={tabelPembacaTerbanyak}
                    className='card-xxl-stretch mb-5 mb-xl-8'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-xl-12'>
          <div className='card card-xl-strech mb-5 mb-xl-8'>
            <div className='card-body d-flex flex-column justify-content-between'>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                10 PERPUSTAKAAN TERATAS BERDASARKAN JUMLAH KOLEKSI TERBACA
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Di {kota === '' ? 'Semua Kota' : kota},{' '}
                {jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang}
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
              </h2>
              <div className='row d-flex justify-content-center align-items-center'>
                {!koleksiTerbacaTerbanyak || koleksiTerbacaTerbanyak.length === 0 ? (
                  <div className='col-xl-6'>
                    <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            <div className='table-responsive'>
                              <div className='alert alert-danger text-center' role='alert'>
                                {loadingDataKoleksiTerbacaTerbanyak ? (
                                  <div className='d-flex align-items-center justify-content-center'>
                                    <Spinner animation='border' role='status' /> <br />
                                  </div>
                                ) : (
                                  <div>TIDAK ADA DATA</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='col-xl-6'>
                    <div
                      className={`card card-xl-stretch mb-5 mb-xl-8`}
                      style={{ backgroundColor: '#efefef' }}
                    >
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            {loadingDataKoleksiTerbacaTerbanyak ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' role='status' /> <br />
                              </div>
                            ) : chartDataKoleksiTerbacaTerbanyak &&
                              chartDataKoleksiTerbacaTerbanyak.labels.length > 0 ? (
                              <KoleksiTerbacaTerbanyak
                                chartDataKoleksiTerbacaTerbanyak={chartDataKoleksiTerbacaTerbanyak}
                              />
                            ) : (
                              <div className='alert alert-danger text-center'>Tidak ada data</div>
                            )}
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                )}
                <div className='col-xl-6'>
                  <TablesWidgetKoleksiTerbacaTerbanyak
                    kota={kota}
                    jenjang={jenjang}
                    idJenjang={idJenjang}
                    idKota={idKota}
                    periode={periode}
                    periodeAwal={periodeAwal}
                    periodeAkhir={periodeAkhir}
                    bulanAwal={bulanAwal}
                    bulanAkhir={bulanAkhir}
                    tahunAwal={tahunAwal}
                    tahunAkhir={tahunAkhir}
                    svgIcon='cloud-download'
                    loading={loading}
                    tabelKoleksiTerbacaTerbanyak={tabelKoleksiTerbacaTerbanyak}
                    className='card-xxl-stretch mb-5 mb-xl-8'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-xl-12'>
          <div className='card card-xl-strech mb-5 mb-xl-8'>
            <div className='card-body d-flex flex-column justify-content-between'>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                10 PERPUSTAKAAN TERATAS BERDASARKAN DURASI BACA TERLAMA
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Di {kota === '' ? 'Semua Kota' : kota},{' '}
                {jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang}
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
              </h2>
              <div className='row d-flex justify-content-center align-items-center'>
                {!durasiTerlama || durasiTerlama.length === 0 ? (
                  <div className='col-xl-6 mb-5 mb-xl-8'>
                    <div className={`card card-xl-stretch`}>
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <div className='m-100'>
                          <div className='table-responsive'>
                            <div className='alert alert-danger text-center' role='alert'>
                              {loadingDataDurasiTerlama ? (
                                <div className='d-flex align-items-center justify-content-center'>
                                  <Spinner animation='border' role='status' /> <br />
                                </div>
                              ) : (
                                <div>TIDAK ADA DATA</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='col-xl-6'>
                    <div className={`card card-xl-stretch`} style={{ backgroundColor: '#efefef' }}>
                      <div className='card-body d-flex flex-column justify-content-between mb-xl-9'>
                        <div className='m-100'>
                          {loadingDataDurasiTerlama ? (
                            <div className='d-flex align-items-center justify-content-center'>
                              <Spinner animation='border' role='status' /> <br />
                            </div>
                          ) : chartDataDurasiTerlama && chartDataDurasiTerlama.labels.length > 0 ? (
                            <DurasiTerlama
                              chartDataDurasiTerlama={chartDataDurasiTerlama}
                            // Menyesuaikan lebar dan tinggi secara responsif
                            />
                          ) : (
                            <div className='alert alert-danger text-center'>Tidak ada data</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className='col-xl-6'>
                  <TablesWidgetDurasiTerlama
                    kota={kota}
                    jenjang={jenjang}
                    idJenjang={idJenjang}
                    idKota={idKota}
                    periode={periode}
                    periodeAwal={periodeAwal}
                    periodeAkhir={periodeAkhir}
                    bulanAwal={bulanAwal}
                    bulanAkhir={bulanAkhir}
                    tahunAwal={tahunAwal}
                    tahunAkhir={tahunAkhir}
                    svgIcon='cloud-download'
                    loading={loading}
                    tabelDurasiTerlama={tabelDurasiTerlama}
                    className='card-xxl-stretch mb-5 mb-xl-8'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-xl-12'>
          <div className='card card-xl-strech mb-5 mb-xl-8'>
            <div className='card-body d-flex flex-column justify-content-between'>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                10 PERPUSTAKAAN TERATAS BERDASARKAN PENGUNJUNG TERBANYAK
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Di {kota === '' ? 'Semua Kota' : kota},{' '}
                {jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang}
              </h2>
              <h2 className='text-dark fw-bold mb-5 text-center'>
                Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
              </h2>
              <div className='row d-flex justify-content-center align-items-center'>
                {!pengunjungTerbanyak || pengunjungTerbanyak.length === 0 ? (
                  <div className='col-xl-6'>
                    <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            <div className='table-responsive'>
                              <div className='alert alert-danger text-center' role='alert'>
                                {loadingPengunjungTerbanyak ? (
                                  <div className='d-flex align-items-center justify-content-center'>
                                    <Spinner animation='border' role='status' /> <br />
                                  </div>
                                ) : (
                                  <div>TIDAK ADA DATA</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='col-xl-6'>
                    <div
                      className={`card card-xl-stretch mb-5 mb-xl-8`}
                      style={{ backgroundColor: '#efefef' }}
                    >
                      <div className='card-body d-flex flex-column justify-content-between'>
                        <>
                          <div className='m-100'>
                            {loading ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' role='status' /> <br />
                              </div>
                            ) : chartDataPengunjungTerbanyak &&
                              chartDataPengunjungTerbanyak.labels.length > 0 ? (
                              <PengunjungTerbanyak
                                chartDataPengunjungTerbanyak={chartDataPengunjungTerbanyak}
                              />
                            ) : (
                              <div className='alert alert-danger text-center'>Tidak ada data</div>
                            )}
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                )}
                <div className='col-xl-6'>
                  <TablesWidgetPengunjungTerbanyak
                    kota={kota}
                    jenjang={jenjang}
                    idJenjang={idJenjang}
                    idKota={idKota}
                    periode={periode}
                    periodeAwal={periodeAwal}
                    periodeAkhir={periodeAkhir}
                    bulanAwal={bulanAwal}
                    bulanAkhir={bulanAkhir}
                    tahunAwal={tahunAwal}
                    tahunAkhir={tahunAkhir}
                    svgIcon='cloud-download'
                    loading={loadingPengunjungTerbanyak}
                    tabelPengunjungTerbanyak={tabelPengunjungTerbanyak}
                    className='card-xxl-stretch mb-5 mb-xl-8'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* begin::Row */}
        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            <ChartPengguna
              loading={loadingDurasiPengguna}
              className='card-xxl-stretch-50 mb-5 mb-xl-8'
              series={[
                {
                  name: 'Pengguna',
                  data: durasiPengguna,
                },
              ]}
              options={{
                chart: {
                  height: 350,
                  type: 'area',
                },
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  curve: 'smooth',
                },
                xaxis: {
                  categories: labelsPengguna,
                },
                tooltip: {
                  x: {
                    // format: 'MM'
                  },
                },
              }}
              totalPengguna={totalPengguna}
              kota={kota}
              jenjang={jenjang}
              mitra={mitra}
              bulanAwal={bulanAwal}
              bulanAkhir={bulanAkhir}
              tahunAwal={tahunAwal}
              tahunAkhir={tahunAkhir}
              onPointClick={handlePenggunaPointClick}
            />
          </div>
        </div>

        {/* <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            {loadingDurasiKoleksi ? (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' role='status' /> <br />
              </div>
            ) : Array.isArray(durasiKoleksi) && durasiKoleksi.length > 0 ? (
              <ChartKoleksi
                bulanAwal={bulanAwal}
                bulanAkhir={bulanAkhir}
                tahunAwal={tahunAwal}
                tahunAkhir={tahunAkhir}
                loading={loading}
                className='card-xxl-stretch-50 mb-5 mb-xl-8'
                series={[
                  {
                    name: 'Koleksi',
                    data: durasiKoleksi,
                  },
                ]}
                options={{
                  chart: {
                    height: 350,
                    type: 'area',
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                  },
                  xaxis: {
                    categories: labelsKoleksi,
                  },
                  tooltip: {
                    x: {
                      // format: 'MM'
                    },
                  },
                }}
                totalKoleksi={totalKoleksi}
                kalimatBaru1={''}
                kalimatBaru2={''}
                kota={kota}
                jenjang={jenjang}
              />
            ) : (
              <div className='col-xxl-12'>
                <div className='card card-xxl-stretch-50 mb-5 mb-xl-8 container'>
                  <div className='card-body d-flex flex-column p-0'>
                    <div className='flex-grow-1 card-p pb-0'>
                      <div className='d-flex flex-stack flex-wrap'>
                        <div className='me-2'>
                          <div className='text-dark text-hover-primary fw-bold fs-3'>
                            Statistik Koleksi
                          </div>
                        </div>
                        <div className={`fw-bold fs-3 `}></div>
                      </div>
                      <div className='mixed-widget-7-chart card-rounded-bottom'>
                        {loadingDurasiKoleksi ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' role='status' /> <br />
                          </div>
                        ) : (
                          <div className='alert alert-danger text-center'>Tidak ada data</div>
                        )}{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div> */}

        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            {loadingDurasiPembaca ? (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' role='status' /> <br />
              </div>
            ) : Array.isArray(durasiPembaca) && durasiPembaca.length > 0 ? (
              <ChartPembaca
                bulanAwal={bulanAwal}
                bulanAkhir={bulanAkhir}
                tahunAwal={tahunAwal}
                tahunAkhir={tahunAkhir}
                loading={loadingDurasiPembaca}
                className='card-xxl-stretch-50 mb-5 mb-xl-8'
                series={[
                  {
                    name: 'Pembaca',
                    data: durasiPembaca,
                  },
                ]}
                options={{
                  chart: {
                    height: 350,
                    type: 'area',
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                  },
                  xaxis: {
                    categories: labelsPembaca,
                  },
                  tooltip: {
                    x: {
                      // format: 'MM'
                    },
                  },
                }}
                totalPembaca={totalPembaca}
                kota={kota}
                jenjang={jenjang}
                mitra={mitra}
                onPointClick={handlePembacaPointClick}
              />
            ) : (
              <div className='col-xxl-12'>
                <div className='card card-xxl-stretch-50 mb-5 mb-xl-8 container'>
                  <div className='card-body d-flex flex-column p-0'>
                    <div className='flex-grow-1 card-p pb-0'>
                      <div className='d-flex flex-stack flex-wrap'>
                        <div className='me-2'>
                          <div className='text-dark text-hover-primary fw-bold fs-3'>
                            Statistik Pembaca
                          </div>
                        </div>
                        <div className={`fw-bold fs-3 `}></div>
                      </div>
                      <div className='mixed-widget-7-chart card-rounded-bottom'>
                        {loading ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' role='status' /> <br />
                          </div>
                        ) : (
                          <div className='alert alert-danger text-center'>Tidak ada data</div>
                        )}{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            {loadingDurasiKoleksiDibaca ? (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' role='status' /> <br />
              </div>
            ) : Array.isArray(durasiKoleksiDibaca) && durasiKoleksiDibaca.length > 0 ? (
              <ChartKoleksiDibaca
                bulanAwal={bulanAwal}
                bulanAkhir={bulanAkhir}
                tahunAwal={tahunAwal}
                tahunAkhir={tahunAkhir}
                loading={loadingDurasiKoleksiDibaca}
                className='card-xxl-stretch-50 mb-5 mb-xl-8'
                series={[
                  {
                    name: 'Koleksi Dibaca',
                    data: durasiKoleksiDibaca,
                  },
                ]}
                options={{
                  chart: {
                    height: 350,
                    type: 'area',
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                  },
                  xaxis: {
                    categories: labelsKoleksiDibaca,
                  },
                  tooltip: {
                    x: {
                      // format: 'MM'
                    },
                  },
                }}
                totalKoleksiDibaca={totalKoleksiDibaca}
                kota={kota}
                jenjang={jenjang}
                mitra={mitra}
                onPointClick={handleKoleksiDibacaPointClick}
              />
            ) : (
              <div className='col-xxl-12'>
                <div className='card card-xxl-stretch-50 mb-5 mb-xl-8 container'>
                  <div className='card-body d-flex flex-column p-0'>
                    <div className='flex-grow-1 card-p pb-0'>
                      <div className='d-flex flex-stack flex-wrap'>
                        <div className='me-2'>
                          <div className='text-dark text-hover-primary fw-bold fs-3'>
                            Statistik Koleksi diBaca
                          </div>
                        </div>
                        <div className={`fw-bold fs-3 `}></div>
                      </div>
                      <div className='mixed-widget-7-chart card-rounded-bottom'>
                        {loadingDurasiKoleksiDibaca ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' role='status' /> <br />
                          </div>
                        ) : (
                          <div className='alert alert-danger text-center'>Tidak ada data</div>
                        )}{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            {loadingDurasiBaca ? (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' role='status' /> <br />
              </div>
            ) : Array.isArray(durasiBaca) && durasiBaca.length > 0 ? (
              <MixedWidget10
                bulanAwal={bulanAwal}
                bulanAkhir={bulanAkhir}
                tahunAwal={tahunAwal}
                tahunAkhir={tahunAkhir}
                loading={loadingDurasiBaca}
                className='card-xxl-stretch-50 mb-5 mb-xl-8'
                series={[
                  {
                    name: 'Durasi Baca',
                    data: durasiBaca,
                  },
                ]}
                options={{
                  chart: {
                    height: 350,
                    type: 'area',
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                  },
                  xaxis: {
                    categories: labels,
                  },
                  tooltip: {
                    x: {
                      // format: 'MM'
                    },
                  },
                }}
                totalJam={totalJam}
                kota={kota}
                jenjang={jenjang}
                mitra={mitra}
                onPointClick={handleDurasiBacaPointClick}
              />
            ) : (
              <div className='col-xxl-12'>
                <div className='card card-xxl-stretch-50 mb-5 mb-xl-8 container'>
                  <div className='card-body d-flex flex-column p-0'>
                    <div className='flex-grow-1 card-p pb-0'>
                      <div className='d-flex flex-stack flex-wrap'>
                        <div className='me-2'>
                          <div className='text-dark text-hover-primary fw-bold fs-3'>
                            Statistik Durasi Baca
                          </div>
                        </div>
                        <div className={`fw-bold fs-3 `}></div>
                      </div>
                      <div className='mixed-widget-7-chart card-rounded-bottom'>
                        {loadingDurasiBaca ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' role='status' /> <br />
                          </div>
                        ) : (
                          <div className='alert alert-danger text-center'>Tidak ada data</div>
                        )}{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            {loadingDurasiKunjungan ? (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' role='status' />
              </div>
            ) : Array.isArray(durasiKunjungan) && durasiKunjungan.length > 0 ? (
              <ChartKunjungan
                bulanAwal={bulanAwal}
                bulanAkhir={bulanAkhir}
                tahunAwal={tahunAwal}
                tahunAkhir={tahunAkhir}
                loading={loadingDurasiKunjungan}
                className='card-xxl-stretch-50 mb-5 mb-xl-8'
                series={[
                  {
                    name: 'Kunjungan',
                    data: durasiKunjungan,
                  },
                ]}
                options={{
                  chart: {
                    height: 350,
                    type: 'area',
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                  },
                  xaxis: {
                    categories: labelsKunjungan,
                  },
                  tooltip: {
                    x: {
                      // format: 'MM'
                    },
                  },
                }}
                totalKunjungan={totalKunjungan}
                kota={kota}
                jenjang={jenjang}
                mitra={mitra}
                onPointClick={handleKunjunganPointClick}
              />
            ) : (
              <div className='col-xxl-12'>
                <div className='card card-xxl-stretch-50 mb-5 mb-xl-8 container'>
                  <div className='card-body d-flex flex-column p-0'>
                    <div className='flex-grow-1 card-p pb-0'>
                      <div className='d-flex flex-stack flex-wrap'>
                        <div className='me-2'>
                          <div className='text-dark text-hover-primary fw-bold fs-3'>
                            Statistik Kunjungan
                          </div>
                        </div>
                        <div className={`fw-bold fs-3 `}></div>
                      </div>
                      <div className='mixed-widget-7-chart card-rounded-bottom'>
                        {loadingDurasiKunjungan ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' role='status' /> <br />
                          </div>
                        ) : (
                          <div className='alert alert-danger text-center'>Tidak ada data</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* end::Row */}

        {/* begin::Row */}

        <div className='row gy-5 g-xl-8'>
          <div className='col-xxl-12'>
            <TablePermintaanBuku
              setSearchParams={setSearchParams}
              setPerPage={setPerPage}
              setCurrentPage={setCurrentPage}
              permintaanBuku={permintaanBuku}
              perPage={perPage}
              totalPage={totalPage}
              currentPage={currentPage}
              loading={loadingPermintaanBuku}
              bulanAwal={bulanAwal}
              bulanAkhir={bulanAkhir}
              tahunAwal={tahunAwal}
              tahunAkhir={tahunAkhir}
            />
          </div>
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
